import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import { getCachedData, setCachedData } from "../utils/apiCache";
import { useNetworkStatus } from "../hooks/useNetworkStatus";
import { Link, useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import axios from "axios";
import "bootstrap-daterangepicker/daterangepicker.css";
import { all_routes } from "./router/all_routes";
import Header from "./Header";
import { getEventBusTrackingInfo, isEventTrackableToday, toDateKey, todayKey } from "../utils/eventBusTracking";
import { EventBusArrivingCard, EventBusContactCard } from "./EventBusTrackingPanel";
import { hasUnseenEvents } from "../utils/newEvents";
import { fetchSchoolTimings, getLateInTime } from "../utils/schoolTime";
import { ProductContext } from "../context/AppContext";
import { isExpired } from "./auth/tokenUtils";
// import Staff from "./Staff";

import Swal from "sweetalert2";
import { KJUR } from "jsrsasign";
import {
  FaClipboardList,
  FaRegCalendarCheck,
  FaMoneyBillWave,
  FaFileAlt,
  FaBus,
  FaUserCheck,
  FaCalendarCheck,
  FaBusAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaSyncAlt,
  FaHome,
  FaBell,
  FaThLarge,
  FaSchool,
  FaArrowLeft,
  FaBook,
  FaBookOpen,
  FaHeartbeat,
  FaChevronRight,
  FaChevronDown,
  FaChevronUp,
  FaArrowRight,
  FaComments,
  FaUserTie,
  FaUsers,
  FaUtensils,
  FaShoppingCart,
  FaEye,
  FaKey,
  FaRunning,
  FaCalendarAlt,
  FaRuler,
  FaBars,
  FaMap,
  FaLocationArrow,
  FaLowVision,
  FaMapMarkerAlt,
  FaMapMarkedAlt,
  FaMapMarker,
  FaEdit,
  FaPhone,
  FaPrescriptionBottle,
  FaPeopleArrows,
  FaInfoCircle,
  FaExclamationTriangle,
  FaSearch,
} from "react-icons/fa";
import {
  TbFileText,
  TbCalendarCheck,
  TbBell,
  TbTrophy,
  TbFileCheck,
  TbClock,
  TbBus,
  TbIdBadge2,
  TbBook,
  TbBooks,
  TbCalendarStats,
  TbFirstAidKit,
  TbUserPlus,
  TbGridDots,
  TbMessage2,
  TbClipboardList,
  TbUserCheck,
  TbEye,
} from "react-icons/tb";



import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { SocketContext } from "../context/socketContext";
import SidebarHeader from "./SidebarHeader";
import CommonSidebar from "../Common/CommonSidebar";
import CommonFooterNav from "../Common/CommonFooterNav";


const InfoTile = ({ card }) => {
  return (
    <div className="info-card shadow-sm">
      <div className="info-card-head">
        <div className="d-flex align-items-center gap-2">
          {card.icon && <span className="info-card-leading-icon">{card.icon}</span>}
          <div>
            {card.eyebrow && (
              <span className="info-card-eyebrow">{card.eyebrow}</span>
            )}
            <h5 className="info-card-title">{card.title}</h5>
          </div>
        </div>
        {card.badge && (
          <span className={`badge ${card.badge.variant || "bg-primary"}`}>
            {card.badge.icon && (
              <span className="info-card-badge-icon me-1">{card.badge.icon}</span>
            )}
            {card.badge.label}
          </span>
        )}
      </div>
      {card.description && (
        <p className="info-card-desc mb-3">{card.description}</p>
      )}
      {card.rows?.length > 0 && (
        <dl className="info-card-rows">
          {card.rows.map((row, idx) => (
            <div
              className="info-card-row d-flex justify-content-between"
              key={`${card.key}-row-${idx}`}
            >
              <dt>{row.label}</dt>
              <dd>{row.value ?? "N/A"}</dd>
            </div>
          ))}
        </dl>
      )}
      {card.tags?.length > 0 && (
        <div className="info-card-tags mb-3">
          {card.tags.map((tag, index) => (
            <span
              key={`${card.key}-tag-${index}`}
              className="badge bg-light text-dark"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
      {card.actions?.length > 0 && (
        <div className="info-card-actions">
          {card.actions.map((action, idx) =>
            action.to ? (
              <Link
                key={`${card.key}-action-${idx}`}
                to={action.to}
                state={action.state}
                target={action.target}
                className={`btn btn-sm ${action.variant || "btn-outline-primary"
                  }`}
              >
                {action.label}
              </Link>
            ) : (
              <button
                key={`${card.key}-action-${idx}`}
                type="button"
                onClick={action.onClick}
                className={`btn btn-sm ${action.variant || "btn-outline-primary"
                  }`}
              >
                {action.label}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
};

const ANY_UPDATE_ALERT_DURATION_MS = 8000;

const notificationModules = [
  { id: 8, label: "Communication" },
  { id: 7, label: "Time Table" },
  { id: 9, label: "Transport" },
  { id: 11, label: "MANAGEMENT" },
  { id: 12, label: "HRM" },
  { id: 3, label: "Visitor" },
  { id: 10, label: "Event" },
];

const notificationSelectOptions = [
  { value: "All", label: "All Modules" },
  ...notificationModules.map((m) => ({ value: String(m.id), label: m.label })),
];

const getModuleIcon = (label) => {
  switch (label) {
    case "Communication":
      return <FaComments />;
    case "Time Table":
      return <FaClock />;
    case "Transport":
      return <FaBus />;
    case "MANAGEMENT":
      return <FaUserTie />;
    case "HRM":
      return <FaUsers />;
    case "Visitor":
      return <FaUserCheck />;
    case "Event":
      return <FaCalendarAlt />;
    default:
      return <FaComments />;
  }
};

// Anything under a day old gets the "New" pill
const isFreshNotification = (dateStr) => {
  if (!dateStr) return false;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return false;
  return Date.now() - date.getTime() < 86400000;
};

const getModuleLabel = (moduleId) => {
  const found = notificationModules.find((m) => Number(m.id) === Number(moduleId));
  return found ? found.label : "General";
};

// "Just now" / "5m ago" / "3h ago" / "2d ago" / date - keeps panel rows scannable
const formatRelativeTime = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diffSec < 0) return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
  if (diffSec < 60) return "Just now";
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  if (diffSec < 604800) return `${Math.floor(diffSec / 86400)}d ago`;
  return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};


const extractEventBookingsPayload = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.message)) return payload.message;
  if (Array.isArray(payload.bookings)) return payload.bookings;
  if (Array.isArray(payload.result)) return payload.result;
  if (payload.data && typeof payload.data === "object" && (payload.data.id || payload.data.event_ctgry_id || payload.data.category)) {
    return [payload.data];
  }
  if (payload.message && typeof payload.message === "object" && (payload.message.id || payload.message.event_ctgry_id || payload.message.category)) {
    return [payload.message];
  }
  if (typeof payload === "object" && (payload.id || payload.event_ctgry_id || payload.category || payload.category_id)) {
    return [payload];
  }
  return [];
};

const getSubstituteList = (record) => {
  if (!record) return [];
  const raw = record.vehicle_substitute;
  if (Array.isArray(raw)) {
    return raw.filter(Boolean);
  }
  if (raw && typeof raw === "object") {
    return [raw];
  }
  if (record.substitute_vehicle_details) {
    return [record.substitute_vehicle_details];
  }
  return [];
};

const format12HourTime = (timeStr) => {
  if (!timeStr) return "";
  const parts = String(timeStr).trim().split(":");
  if (parts.length < 2) return timeStr;
  let hours = parseInt(parts[0], 10);
  const minutes = parts[1];
  if (isNaN(hours)) return timeStr;
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${hours}:${minutes} ${ampm}`;
};

const parseTimeToSeconds = (timeStr) => {
  if (!timeStr) return null;
  const parts = String(timeStr).trim().split(":");
  if (parts.length < 2) return null;
  const h = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  const s = parts[2] ? parseInt(parts[2], 10) : 0;
  if (isNaN(h) || isNaN(m)) return null;
  return h * 3600 + m * 60 + (isNaN(s) ? 0 : s);
};

const isCurrentTimeInRange = (startStr, endStr) => {
  const startSec = parseTimeToSeconds(startStr);
  const endSec = parseTimeToSeconds(endStr);
  if (startSec === null || endSec === null) return true;

  const d = new Date();
  const currentSec = d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();

  if (startSec <= endSec) {
    return currentSec >= startSec && currentSec <= endSec;
  } else {
    return currentSec >= startSec || currentSec <= endSec;
  }
};

// Which leg of the day the parent is currently in. The pickup leg stays active
// until the pickup window ends, after that the drop leg takes over.
const getCurrentTransportPhase = (record) => {
  const pickEndSec = parseTimeToSeconds(record?.pick_end_time);
  const dropStartSec = parseTimeToSeconds(record?.drop_start_time);

  const d = new Date();
  const currentSec = d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();

  if (pickEndSec !== null) {
    return currentSec <= pickEndSec ? "pick" : "drop";
  }
  if (dropStartSec !== null) {
    return currentSec >= dropStartSec ? "drop" : "pick";
  }
  return null;
};

// A substitute is assigned for "pick", "drop" or "pick & drop". Anything that
// covers both legs (or carries no trip at all) is treated as "both".
const normalizeSubstituteTrip = (trip) => {
  const value = String(trip || "").toLowerCase().trim();
  const hasPick = value.includes("pick");
  const hasDrop = value.includes("drop");
  if (hasPick && !hasDrop) return "pick";
  if (hasDrop && !hasPick) return "drop";
  return "both";
};

// A substitute applies to the given leg when it was assigned for that trip or
// for both legs.
const isSubstituteForPhase = (sub, phase) => {
  const trip = normalizeSubstituteTrip(sub?.trip);
  if (trip === "both" || !phase) return true;
  return trip === phase;
};

// Substitutes that are still relevant right now. A bus substituted only for the
// morning pickup must stop showing once the pickup window is over, so parents
// see the original bus for the afternoon drop.
const getActiveSubstituteList = (record) => {
  const phase = getCurrentTransportPhase(record);
  const subList = getSubstituteList(record);
  if (!phase) return subList;
  return subList.filter((sub) => isSubstituteForPhase(sub, phase));
};


const Home = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const { notificationlist = [], requestBrowserNotificationPermission } = useContext(SocketContext) || {};
  const hasNotificationAlert = notificationlist.some((item) => !item?.seen);
  const [date, setDate] = useState(null);
  const [selectedModule, setSelectedModule] = useState("All");
  const [searchNotification, setSearchNotification] = useState("");

  const {
    userType,
    userId,
    getenquiry,
    getRegistration,
    GetstudentData,
    userData,
    fetchUserProfileData,
    getMenuList,
    StudentProfileData,
    Session,
    HouseData,
    fetchHouseData
  } = useContext(ProductContext);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showTrackModal, setShowTrackModal] = useState(false);
  const [trackLoading, setTrackLoading] = useState(true);
  const [trackReloadKey, setTrackReloadKey] = useState(0);
  const [showTransportDetails, setShowTransportDetails] = useState(false);
  const [showBusDriverDetails, setShowBusDriverDetails] = useState(true);
  const trackMapReadyTimerRef = useRef(null);

  const handleOpenTrackModal = () => {
    setTrackLoading(true);
    setShowTrackModal(true);
  };

  // The iframe's onLoad fires once its own document is ready, well before the
  // vector map inside it finishes fetching style.json and rendering tiles.
  // Give it a bit more time after that before hiding the loader.
  const handleTrackMapFrameLoad = () => {
    if (trackMapReadyTimerRef.current) {
      clearTimeout(trackMapReadyTimerRef.current);
    }
    trackMapReadyTimerRef.current = setTimeout(() => {
      setTrackLoading(false);
    }, 2500);
  };

  const handleRefreshTrackMap = () => {
    if (trackMapReadyTimerRef.current) {
      clearTimeout(trackMapReadyTimerRef.current);
      trackMapReadyTimerRef.current = null;
    }
    setTrackLoading(true);
    setTrackReloadKey((prev) => prev + 1);
  };

  useEffect(() => {
    return () => {
      if (trackMapReadyTimerRef.current) {
        clearTimeout(trackMapReadyTimerRef.current);
      }
    };
  }, []);


  const selectedHouse = HouseData?.data?.find(
    (house) =>
      house.id === Number(GetstudentData?.house_id) ||
      house.id === Number(GetstudentData?.house) ||
      (GetstudentData?.house_name && String(house.name).toLowerCase() === String(GetstudentData?.house_name).toLowerCase()) ||
      (GetstudentData?.house && String(house.name).toLowerCase() === String(GetstudentData?.house).toLowerCase())
  );

  const [isRefreshingHouse, setIsRefreshingHouse] = useState(false);

  const handleRefreshHouse = () => {
    setIsRefreshingHouse(true);
    window.location.reload();
  };
  const navigation = useNavigate();

  const cachedDashboard = getCachedData('dashboard_data');
  const [Dashboarddata, setDashboarddata] = useState(cachedDashboard || null);
  const [Automationdata, setAutomationdata] = useState(getCachedData('automation_data') || null);
  const [anyUpdateAlerts, setAnyUpdateAlerts] = useState([]);
  const [UpdatedataApp, setUpdatedataApp] = useState(getCachedData('update_data_app') || null);
  const [loading, setLoading] = useState(!cachedDashboard);
  const { showSlowMsg, message } = useNetworkStatus(loading, 4000);

  

  const authtoken = localStorage.getItem("token");
  const hasToken = Boolean(authtoken);
  const tokenExpired = hasToken && isExpired(authtoken);
  const isTokenValid = hasToken && !tokenExpired;
  const [studentId, setStudentId] = useState(getCachedData('dashboard_student_id') || null);
  const [StudentData, setStudentData] = useState(getCachedData('dashboard_student_data') || null);
  const cachedTransportData = getCachedData('dashboard_transport_data');
  const hasValidCachedTransport = cachedTransportData && (
    Array.isArray(cachedTransportData?.data)
      ? cachedTransportData.data.length > 0
      : (Array.isArray(cachedTransportData) && cachedTransportData.length > 0)
  );
  const [TransportData, setTransportData] = useState(cachedTransportData || null);
  const [loadingTransport, setLoadingTransport] = useState(!hasValidCachedTransport);
  const hasTransport = TransportData?.data?.length > 0 || (Array.isArray(TransportData) && TransportData.length > 0) ? true : TransportData == null ? '' : false;
  const [attendanceSummaryData, setAttendanceSummaryData] = useState(getCachedData('dashboard_attendance_summary') || null);
  const [transportAttendanceSummaryData, setTransportAttendanceSummaryData] =
    useState(getCachedData('dashboard_transport_summary') || null);
  const [todayAttendanceStatus, setTodayAttendanceStatus] = useState(getCachedData('dashboard_today_attendance') || null);
  // In time when the student arrived late today (present after school start), else null
  const [todayLateInTime, setTodayLateInTime] = useState(getCachedData('dashboard_today_late_in_time') || null);
  const [todayEventAttendance, setTodayEventAttendance] = useState(getCachedData('dashboard_today_event_attendance') || []);

  const groupedEventAttendance = useMemo(() => {
    if (!Array.isArray(todayEventAttendance) || todayEventAttendance.length === 0) {
      return [];
    }

    const map = new Map();
    todayEventAttendance.forEach((item) => {
      const key = item.event_id || item.event_name?.trim();
      if (!map.has(key)) {
        map.set(key, {
          event_id: item.event_id,
          event_name: item.event_name,
          date: item.date,
          start_date: item.start_date,
          end_date: item.end_date,
          due_date: item.due_date,
          vehicle_route_url: item.vehicle_route_url,
          attendances: [],
        });
      }
      const group = map.get(key);
      group.attendances.push(item);
      if (item.vehicle_route_url) group.vehicle_route_url = item.vehicle_route_url;
    });

    return Array.from(map.values());
  }, [todayEventAttendance]);

  // Booked events are needed on their own: attendance may not be marked yet (or
  // at all), and a parent must still be able to track the bus of an event that
  // is running today.
  const [eventBookings, setEventBookings] = useState(getCachedData('dashboard_event_bookings') || []);

  const findEventBooking = useCallback((eventId, eventName) => {
    if (!Array.isArray(eventBookings)) return null;
    return (
      eventBookings.find(
        (b) =>
          (eventId && Number(b?.event_ctgry_id) === Number(eventId)) ||
          (eventId && Number(b?.category?.id) === Number(eventId))
      ) ||
      (eventName
        ? eventBookings.find(
          (b) => String(b?.category?.title || "").trim().toLowerCase() === String(eventName).trim().toLowerCase()
        )
        : null) ||
      null
    );
  }, [eventBookings]);

  const todayEventBookings = useMemo(() => {
    if (!Array.isArray(eventBookings) || eventBookings.length === 0) return [];

    return eventBookings.filter((booking) => {
      if (!booking || booking?.is_deleted === true || booking?.is_active === false) return false;

      const status = String(booking?.status || "").toLowerCase();
      if (["rejected", "cancelled", "canceled", "declined"].includes(status)) return false;

      const category = booking?.category || {};
      if (category?.is_act === false) return false;

      // Runs today: start/end date cover the current date (due date is the
      // fallback when the school did not set an end). The bus is not required
      // here - the event still belongs on today's list, and only the tracking
      // button waits for the school to map a vehicle.
      return isEventTrackableToday(category) || isEventTrackableToday(booking);
    });
  }, [eventBookings]);

  // Today's event rows: the marked attendances first, then any event running
  // today whose attendance has not been marked.
  const eventTrackCards = useMemo(() => {
    const cards = groupedEventAttendance.map((group) => ({
      ...group,
      booking: findEventBooking(group.event_id, group.event_name),
    }));

    todayEventBookings.forEach((booking) => {
      const category = booking?.category || {};
      const eventId = booking?.event_ctgry_id || category?.id;
      const title = category?.title;

      const alreadyListed = cards.some(
        (card) =>
          (card.event_id && eventId && Number(card.event_id) === Number(eventId)) ||
          (title && String(card.event_name || "").trim().toLowerCase() === String(title).trim().toLowerCase())
      );
      if (alreadyListed) return;

      // The booking API carries the event's own attendance (pickup/dropoff),
      // which the date-wise attendance API does not return.
      const today = todayKey();
      const bookingAttendances = (Array.isArray(booking?.eventAttendance) ? booking.eventAttendance : [])
        .filter((att) => toDateKey(att?.date) === today);

      cards.push({
        event_id: eventId,
        event_name: title,
        date: null,
        start_date: category?.start_date,
        end_date: category?.end_date,
        due_date: category?.due_date,
        vehicle_route_url: null,
        attendances: bookingAttendances,
        booking,
      });
    });

    console.log(cards, "today event cards (attendance + booked events)");
    return cards;
  }, [groupedEventAttendance, todayEventBookings, findEventBooking]);

  const [isEventAttendanceCollapsed, setIsEventAttendanceCollapsed] = useState(false);
  const [showEventTrackModal, setShowEventTrackModal] = useState(false);
  const [eventTrackLoading, setEventTrackLoading] = useState(false);
  const [selectedEventTrackUrl, setSelectedEventTrackUrl] = useState("");
  const [selectedEventTrackTitle, setSelectedEventTrackTitle] = useState("");
  const [eventTrackVehicleOptions, setEventTrackVehicleOptions] = useState([]);
  const [activeEventTrackItem, setActiveEventTrackItem] = useState(null);
  const [activeEventTrackBooking, setActiveEventTrackBooking] = useState(null);
  const [eventTrackBusInfo, setEventTrackBusInfo] = useState(null);

  const formatDateDisplay = (dateStr) => {
    if (!dateStr) return "N/A";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };

  const isEventTrackingTimeAllowed = (evItem, eventBooking) => {
    const startStr = evItem.start_date || eventBooking?.start_date || eventBooking?.category?.start_date;
    const endStr = evItem.end_date || eventBooking?.end_date || eventBooking?.category?.end_date || evItem.due_date || eventBooking?.due_date || eventBooking?.category?.due_date;

    if (!startStr && !endStr) return true;

    const now = new Date();

    let startDate = startStr ? new Date(startStr) : null;
    if (startDate) startDate.setHours(0, 0, 0, 0);

    let endDate = endStr ? new Date(endStr) : null;
    if (endDate) endDate.setHours(23, 59, 59, 999);

    if (startDate && now < startDate) return false;
    if (endDate && now > endDate) return false;

    return true;
  };

  const handleTrackEventVehicle = async (item, knownBooking) => {
    setEventTrackLoading(true);
    setSelectedEventTrackTitle(item.event_name ? item.event_name.trim() : "Event Vehicle Tracking");
    setShowEventTrackModal(true);
    setSelectedEventTrackUrl("");
    setEventTrackVehicleOptions([]);
    setActiveEventTrackItem(item);
    setActiveEventTrackBooking(null);
    setEventTrackBusInfo(null);

    const fallbackUrl = item.vehicle_route_url || item.vehicle_url || item.url;
    let foundBooking = knownBooking || findEventBooking(item.event_id, item.event_name);

    // Only hit the network when the booking is not already on the dashboard.
    if (!foundBooking && studentId) {
      try {
        const res = await axios.get(
          `https://api.mirai.healthcare/api/student-details/event-booking/student?student_id=${studentId}`,
          { headers: { "x-auth": authtoken } }
        );
        const bookings = extractEventBookingsPayload(res.data);
        foundBooking = bookings.find(
          (b) => b.event_ctgry_id === item.event_id || b.category?.id === item.event_id
        );
      } catch (err) {
        console.error("Error fetching event vehicle track URL:", err);
      }
    }

    setActiveEventTrackBooking(foundBooking);

    // A substitute assigned for today is the bus that will actually arrive, so it
    // wins over the regular bus for both the map and the contact numbers.
    const busInfo = getEventBusTrackingInfo(foundBooking, item, fallbackUrl);
    setEventTrackBusInfo(busInfo);
    setEventTrackVehicleOptions(busInfo.vehicleOptions);
    setSelectedEventTrackUrl(busInfo.activeTrackUrl || "");
    setEventTrackLoading(false);
  };
  const [todayTransportAttendanceStatus, setTodayTransportAttendanceStatus] =
    useState(getCachedData('dashboard_today_transport') || null);

  const [siblingAccounts, setSiblingAccounts] = useState([]);
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  // const [Dashboarddata, setDashboarddata] = useState(null);

  const [activeSiblingUser, setActiveSiblingUser] = useState(
    typeof window !== "undefined" ? localStorage.getItem("activeUser") || "" : ""
  );
  useEffect(() => {
    const updateView = () => {
      if (typeof window === "undefined") return;
      setIsMobileView(window.innerWidth <= 768);
    };
    updateView();
    window.addEventListener("resize", updateView);
    return () => window.removeEventListener("resize", updateView);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const storedSiblings =
        JSON.parse(localStorage.getItem("siblings")) || [];
      setSiblingAccounts(storedSiblings);
    } catch (err) {
      console.error("Error parsing sibling accounts:", err);
      setSiblingAccounts([]);
    }
    setActiveSiblingUser(localStorage.getItem("activeUser") || "");
  }, []);

  const isDueFeeLocked = Dashboarddata?.data?.due_fee?.is_show_due_fee === true;
  const isDueFee = Dashboarddata?.data?.is_fee_due === true;
  const handleRestrictedClick = (event) => {
    if (isDueFeeLocked) {
      event.preventDefault();
      event.stopPropagation();
    }
  };


  const handleAccountSwitchClick = (event) => {
    // if (isDueFeeLocked) {
    //   handleRestrictedClick(event);
    //   return;
    // }
    if (isMobileView || siblingAccounts.length === 0) {
      navigation(routes.accountswitch);
      return;
    }
    event.preventDefault();
    setIsAccountDropdownOpen((prev) => !prev);
  };
  const handleAccountSelection = (sibling) => {
    if (!sibling?.token) {
      Swal.fire({
        icon: "error",
        title: "Unable to switch account",
        text: "Selected account is missing credentials.",
      });
      return;
    }
    localStorage.setItem("token", sibling.token);
    localStorage.setItem("activeUser", sibling.username);
    localStorage.setItem("full_name", sibling.full_name);
    setActiveSiblingUser(sibling.username);
    setIsAccountDropdownOpen(false);
    Swal.fire({
      icon: "success",
      title: "Switched account",
      text: `${sibling.full_name} (${sibling.username})`,
      timer: 1500,
      showConfirmButton: false,
    }).then(() => {
      window.location.href = "/";
    });
  };

  console.log(siblingAccounts, 'siblingAccounts data');

  const getHouseBadgeProps = () => {
    const rawColor = selectedHouse?.house_color?.trim() || "";

    if (rawColor) {
      return {
        className: "house-badge",
        style: {
          backgroundColor: rawColor,
          color: "#ffffff",
          border: `1px solid ${rawColor}`,
          fontWeight: "700"
        }
      };
    }

    return { className: "house-badge", style: {} };
  };

  const houseBadgeProps = getHouseBadgeProps();

  const sessionOptions = useMemo(
    () =>
      Array.isArray(Session?.data)
        ? Session.data.map((session) => ({
          value: session.id,
          label: session.Name,
          // isCurrent: session.Is_Current_Session === true,
        }))
        : [],
    [Session]
  );

  const sessionName = sessionOptions.find(
    (item) => item.value === Number(GetstudentData?.session)
  )?.label;

  console.log(HouseData, "HouseData Data");



  const dummyProfileImage = GetstudentData?.upload_photo?.link;

  const profileImage =
    StudentProfileData?.student_image?.trim() ||
    StudentProfileData?.profile_image?.trim() ||
    userData?.currentUser?.profileImage?.trim();

  const ProfilePhoto = dummyProfileImage || profileImage;
  // dummyProfileImage;

  const displayName =
    userData?.currentUser?.full_name ||
    userData?.currentUser?.username ||
    "User Name";




  const menuSections = [
    {
      title: "🎓 Academics",
      className: "gradient-blue",
      items: [
        { title: "Attendance", icon: <FaClipboardList /> },
        { title: "Leave", icon: <FaRegCalendarCheck /> },
        { title: "Time Table", icon: <FaClock /> },
        { title: "Exam TimeTable", icon: <FaCalendarAlt /> },
        // { title: "Examinations", icon: <FaClipboardList /> },
        // { title: "Chapter Test", icon: <FaClipboardList /> },
        // { title: "Home Work", icon: <FaClipboardList /> },
      ],
    },
    {
      title: "📢 Communication",
      className: "gradient-purple",
      items: [
        // { title: "Notice", icon: <FaFileAlt /> },
        { title: "News Letter", icon: <FaBookOpen /> },
        { title: "e-Feedback", icon: <FaComments /> },
        // { title: "Enquiry", icon: <FaUsers /> },
      ],
    },
    {
      title: "📢 Transport",
      className: "gradient-blue",
      items: [
        // { title: "Notice", icon: <FaFileAlt /> },
        { title: "Transport Info", icon: <FaBus /> },
        { title: "Transport Track", icon: <FaBusAlt /> },
        // { title: "Enquiry", icon: <FaUsers /> },
      ],
    },
    {
      title: "🏫 School Services",
      className: "gradient-green",
      items: [
        { title: "School Rules", icon: <FaClipboardList /> },
        { title: "Student Info", icon: <FaUserCheck /> },
        { title: "User Observation", icon: <FaEye /> },
        { title: "Medical Info", icon: <FaHeartbeat /> },
        { title: "Document Request", icon: <FaFileAlt /> },
      ],
    },
    {
      title: "🍔 Facilities",
      className: "gradient-orange",
      items: [
        { title: "Library", icon: <FaBook /> },
        { title: "Canteen", icon: <FaUtensils /> },
        { title: "My Order", icon: <FaShoppingCart /> },
        { title: "Co-Curricular", icon: <FaRunning /> },
        { title: "Event Participation", icon: <FaCalendarAlt /> },
      ],
    },
    {
      title: "💳 Utilities",
      className: "gradient-red",
      items: [
        { title: "Fees Collection", icon: <FaMoneyBillWave /> },
        { title: "Gate Pass", icon: <FaUserCheck /> },
        { title: "Visitor Pass", icon: <FaUserCheck /> },
        { title: "Resend Password", icon: <FaKey /> },
      ],
    },
  ];

  const getSectionIcon = (label) => {
    switch (label?.toLowerCase()) {
      case "academics":
        return "🎓";

      case "communication":
        return "📢";

      case "transport":
        return "🚌";

      case "school services":
        return "🏫";

      case "facilities":
        return "🍔";

      case "utilities":
        return "💳";

      default:
        return "📌";
    }
  };

  const getMenuIcon = (label) => {
    switch (label?.toLowerCase()) {
      case "syllabus":
        return <TbBook />;
      case "library":
        return <TbBooks />;
      case "date sheet":
      case "datesheet":
      case "date-sheet":
        return <TbCalendarStats />;
      case "canteen order":
      case "canteen":
        return <FaUtensils />;
      case "medical info":
        return <TbFirstAidKit />;
      case "visitor pass":
      case "visitor":
        return <TbUserPlus />;
      case "attendance":
        return <TbClipboardList />;
      case "leave":
        return <TbCalendarCheck />;
      case "time table":
        return <TbClock />;
      case "exam timetable":
        return <TbCalendarStats />;
      case "news letter":
        return <TbBook />;
      case "e-feedback":
        return <TbMessage2 />;
      case "transport info":
      case "transport":
        return <TbBus />;
      case "student info":
        return <TbUserCheck />;
      case "my order":
        return <FaShoppingCart />;
      case "fees collection":
      case "fees":
        return <FaMoneyBillWave />;
      case "gate pass":
        return <TbIdBadge2 />;
      default:
        return <TbGridDots />;
    }
  };

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const sortedNotifications = [...notificationlist].sort(
    (a, b) =>
      new Date(b.created_at) -
      new Date(a.created_at)
  );
  const [showNotification, setShowNotification] = useState(false);


  const [selectedNotification, setSelectedNotification] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [visibleNotificationCount, setVisibleNotificationCount] = useState(10);
  const [expandedNotifications, setExpandedNotifications] = useState({});
  const [loadingNotifications, setLoadingNotifications] = useState(false);

  const fetchNotifications = async (modId) => {
    try {
      setLoadingNotifications(true);

      const targetModule = modId !== undefined ? modId : selectedModule;
      const token = localStorage.getItem("token");
      const url = targetModule && targetModule !== "All" && targetModule !== ""
        ? `https://api.mirai.healthcare/notification?module_id=${targetModule}`
        : `https://api.mirai.healthcare/notification`;

      const response = await axios.get(url, {
        headers: {
          accept: "application/json",
          "x-auth": token,
        },
      });

      const rawList = response.data?.data || [];
      const sortedList = [...rawList].sort((a, b) => {
        const timeA = new Date(a.created_at || a.date || a.createdDate || 0).getTime();
        const timeB = new Date(b.created_at || b.date || b.createdDate || 0).getTime();
        if (timeB !== timeA) return timeB - timeA;
        return (b.id || 0) - (a.id || 0);
      });

      setNotifications(sortedList);
    } catch (error) {
      console.log("Notification Error:", error);
    } finally {
      setLoadingNotifications(false);
    }
  };

  useEffect(() => {
    fetchNotifications("All");
  }, []);

  const [expandedSections, setExpandedSections] = useState({});
  const toggleSection = (title) => {
    setExpandedSections((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const filteredNotifications = useMemo(() => {
    return (notifications || [])
      .filter((item) => {
        const search = (searchNotification || "").toLowerCase();
        const matchSearch =
          (item.notification || "").toLowerCase().includes(search) ||
          (item.body || "").toLowerCase().includes(search) ||
          (item.title || "").toLowerCase().includes(search);

        const itemModule = item.module ?? item.module_id ?? item.moduleId;
        const matchModule =
          !selectedModule ||
          selectedModule === "All" ||
          selectedModule === "" ||
          Number(itemModule) === Number(selectedModule);

        return matchSearch && matchModule;
      })
      .sort((a, b) => {
        const timeA = new Date(a.created_at || a.date || a.createdDate || 0).getTime();
        const timeB = new Date(b.created_at || b.date || b.createdDate || 0).getTime();
        if (timeB !== timeA) return timeB - timeA;
        return (b.id || 0) - (a.id || 0);
      });
  }, [notifications, searchNotification, selectedModule]);

  const displayedNotifications = useMemo(() => {
    return filteredNotifications.slice(0, visibleNotificationCount);
  }, [filteredNotifications, visibleNotificationCount]);

  useEffect(() => {
    setVisibleNotificationCount(10);
  }, [searchNotification, selectedModule, notifications]);


  const [menuData, setMenuData] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);

  const fetchMenus = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        "https://api.mirai.healthcare/api/user/menu/web",
        {
          headers: {
            accept: "application/json",
            "x-auth": token,
          },
        }
      );

      setMenuData(response.data.message.menus || []);
    } catch (error) {
      console.log("Menu API Error:", error);
    }
  };

  useEffect(() => {
    fetchMenus();
  }, []);

  const [expandedMenus, setExpandedMenus] = useState({});
  const toggleMenu = (menuId) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

  const isAdmitted = GetstudentData?.is_admitted === true || Dashboarddata?.data?.isAdmission === true;

  const filteredMenuData = useMemo(() => {
    if (!menuData) return [];
    const filtered = menuData
      .map((menu) => {
        const filteredSubitems = (menu?.submenuItems || []).filter((item) => {
          const labelLower = (item?.label || "").toLowerCase().trim();
          if (labelLower === "student transport attendance history") {
            return false;
          }
          if (isAdmitted) {
            if (
              labelLower.includes("registration") ||
              labelLower.includes("enquiry") ||
              labelLower.includes("entrance")
            ) {
              return false;
            }
          }
          return true;
        });


        return {
          ...menu,
          submenuItems: filteredSubitems,
        };
      })
      .filter((menu) => {
        if (isAdmitted) {
          const menuLabelLower = (menu?.label || "").toLowerCase();
          if (
            menuLabelLower.includes("registration") ||
            menuLabelLower.includes("enquiry") ||
            menuLabelLower.includes("entrance")
          ) {
            return false;
          }
        }
        return (menu?.submenuItems || []).length > 0;
      });

    const sequenceOrder = [
      "communication",
      "student information",
      "fees",
      "exam",
      "attendance",
    ];

    return filtered.sort((a, b) => {
      const labelA = (a?.label || "").trim().toLowerCase();
      const labelB = (b?.label || "").trim().toLowerCase();

      const indexA = sequenceOrder.findIndex((seq) => labelA.includes(seq));
      const indexB = sequenceOrder.findIndex((seq) => labelB.includes(seq));

      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;

      return 0;
    });
  }, [menuData, isAdmitted]);





  const PrimaryContactNumber =
    getRegistration?.data?.father_mobile_no ||
    getRegistration?.data?.mother_mobile_no ||
    getRegistration?.data?.guardian_mobile_no;

  const PrimaryContactEmail =
    getRegistration?.data?.father_email ||
    getRegistration?.data?.mother_email ||
    getRegistration?.data?.guardian_email;

  const isDueFeePending =
    Dashboarddata?.data?.due_fee?.is_show_due_fee === true;
  const dueFeeDetails = Dashboarddata?.data?.due_fee;
  const rawDueFeeAmount = dueFeeDetails?.total_due_fee;
  const formattedDueFeeAmount =
    typeof rawDueFeeAmount === "number"
      ? `₹ ${rawDueFeeAmount.toLocaleString("en-IN")}`
      : dueFeeDetails?.display_amount || rawDueFeeAmount;
  const dueFeeMessage =
    dueFeeDetails?.message ||
    "Your fee is still due. Please complete the payment now.";
  const [showDueFeeModal, setShowDueFeeModal] = useState(false);
  const [showDueFeeModal1, setShowDueFeeModal1] = useState(false);
  const automationRecords = Array.isArray(Automationdata?.data)
    ? Automationdata?.data
    : Array.isArray(Automationdata)
      ? Automationdata
      : Automationdata
        ? [Automationdata]
        : [];
  const schoolInfo = automationRecords?.[0] || {};

  const [minTimeDone, setMinTimeDone] = useState(!!cachedDashboard);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMinTimeDone(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (tokenExpired) {
      localStorage.removeItem("token");
      navigate(routes.login, { replace: true });
      return;
    }

    if (isDueFeePending) {
      setShowDueFeeModal(true);
    } else {
      setShowDueFeeModal(false);
    }
  }, [isDueFeePending, navigate, routes.login, tokenExpired]);

  useEffect(() => {
    if (tokenExpired) {
      return;
    }

    const isAndroid = /Android/i.test(navigator.userAgent);
    if (!isAndroid) return;

    if (UpdatedataApp?.is_updated === false) {
      setShowDueFeeModal1(true);
    }
  }, [UpdatedataApp, tokenExpired]);

  const handleUpdate = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.edumanage1",
      "_blank"
    );
  };

  const handleDueFeePay = () => {
    navigate("/FeeCollection");
  };

  const fetchUserData = async () => {
    if (!isTokenValid) {
      console.log("No token found");
      setLoading(false);
      return;
    }
    const cacheKey = 'dashboard_data';
    const cached = getCachedData(cacheKey);
    if (cached) {
      setDashboarddata(cached);
      setLoading(false);
    }
    try {
      const response = await axios.get(
        "https://api.mirai.healthcare/api/register/dashboard",
        {
          headers: {
            "x-auth": `${authtoken}`,
          },
        }
      );
      if (response.data.success) {
        setDashboarddata(response.data);
        setCachedData(cacheKey, response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSchoolAutomationData = async () => {
    const cacheKey = 'automation_data';
    const cached = getCachedData(cacheKey);
    if (cached) {
      setAutomationdata(cached);
    }
    try {
      const headers = authtoken
        ? { "x-auth": `${authtoken}` }
        : { accept: "application/json" };
      const response = await axios.get(
        "https://api.mirai.healthcare/api/head/school-rule/school-automation",
        { headers }
      );
      if (response?.data) {
        setAutomationdata(response.data);
        setCachedData(cacheKey, response.data);
      }
    } catch (error) {
      console.error("Error fetching school automation data:", error);
    }
  };

  const fetchSchoolUpdate = async () => {
    const cacheKey = 'update_data_app';
    const cached = getCachedData(cacheKey);
    if (cached) {
      setUpdatedataApp(cached);
    }
    try {
      const headers = authtoken
        ? { "x-auth": `${authtoken}` }
        : { accept: "application/json" };
      const response = await axios.get(
        "https://api.mirai.healthcare/api/user/fcm-token/check-update",
        { headers }
      );
      if (response?.data) {
        setUpdatedataApp(response.data);
        setCachedData(cacheKey, response.data);
      }
    } catch (error) {
      console.error("Error fetching school automation data:", error);
    }
  };

  useEffect(() => {
    if (!isTokenValid) {
      setLoading(false);
      return;
    }

    fetchUserData();
    fetchSchoolAutomationData();
    fetchSchoolUpdate();
  }, [isTokenValid]);

  useEffect(() => {
    if (!isTokenValid) return;

    const fetchAnyUpdates = async () => {
      try {
        const response = await axios.get(
          "https://api.mirai.healthcare/api/user/anyupdates",
          { headers: { "x-auth": authtoken } }
        );

        const updates = response?.data?.message?.updates || [];
        if (!response?.data?.success || updates.length === 0) return;

        const shownIds = JSON.parse(localStorage.getItem("shown_update_ids") || "[]");
        // is_one_time updates get suppressed once dismissed; recurring (is_one_time: false)
        // updates always come back until the underlying condition (e.g. app update) is resolved.
        const pendingUpdates = updates.filter(
          (item) => item.is_one_time === false || !shownIds.includes(item.id)
        );
        if (pendingUpdates.length === 0) return;

        setAnyUpdateAlerts(pendingUpdates);
      } catch (error) {
        console.error("Error fetching any updates:", error);
      }
    };

    fetchAnyUpdates();
  }, [isTokenValid]);

  const anyUpdateTimersRef = useRef({});

  const dismissAnyUpdateAlert = (update) => {
    if (anyUpdateTimersRef.current[update.id]) {
      clearTimeout(anyUpdateTimersRef.current[update.id]);
      delete anyUpdateTimersRef.current[update.id];
    }
    setAnyUpdateAlerts((prev) => prev.filter((item) => item.id !== update.id));
    if (update.is_one_time === false) return;
    const shownIds = JSON.parse(localStorage.getItem("shown_update_ids") || "[]");
    if (!shownIds.includes(update.id)) {
      localStorage.setItem("shown_update_ids", JSON.stringify([...shownIds, update.id]));
    }
  };

  useEffect(() => {
    anyUpdateAlerts.forEach((update) => {
      if (anyUpdateTimersRef.current[update.id]) return;
      anyUpdateTimersRef.current[update.id] = setTimeout(() => {
        delete anyUpdateTimersRef.current[update.id];
        dismissAnyUpdateAlert(update);
      }, ANY_UPDATE_ALERT_DURATION_MS);
    });
  }, [anyUpdateAlerts]);

  useEffect(() => {
    const timers = anyUpdateTimersRef.current;
    return () => {
      Object.values(timers).forEach(clearTimeout);
    };
  }, []);

  console.log(UpdatedataApp, "UpdatedataApp check data");

  useEffect(() => {
    const fetchStudentId = async () => {
      const cacheKey = `dashboard_student_id_data_${userId}`;
      const cached = getCachedData(cacheKey);
      if (cached) {
        setStudentData(cached);
        setStudentId(cached.id);
        setCachedData('dashboard_student_id', cached.id);
        setCachedData('dashboard_student_data', cached);
        if (cached.fee_cycle_id) {
          localStorage.setItem("fee_cycle_id", cached.fee_cycle_id);
        }
      }
      try {
        const response = await fetch(
          `https://api.mirai.healthcare/api/student?regs_id=${userId}`,
          {
            headers: { "x-auth": `${authtoken}` },
          }
        );
        const data = await response.json();
        if (data.success && data.message.length > 0) {
          const studentData2 = data.message[0];
          setStudentData(studentData2);
          setStudentId(studentData2.id);
          setCachedData(cacheKey, studentData2);
          setCachedData('dashboard_student_id', studentData2.id);
          setCachedData('dashboard_student_data', studentData2);
          if (studentData2.fee_cycle_id) {
            localStorage.setItem("fee_cycle_id", studentData2.fee_cycle_id);
          }
        }
      } catch (err) {
        console.error("Error fetching student ID:", err);
      }
    };

    if (userId && isTokenValid) {
      fetchStudentId();
    }
  }, [userId, isTokenValid]);

  useEffect(() => {
    const fetchTransportData = async () => {
      if (!isTokenValid) {
        setLoadingTransport(false);
        return;
      }
      const cacheKey = 'dashboard_transport_data';
      const cached = getCachedData(cacheKey);
      const hasValidCached = cached && (
        Array.isArray(cached?.data)
          ? cached.data.length > 0
          : (Array.isArray(cached) && cached.length > 0)
      );

      if (hasValidCached) {
        setTransportData(cached);
        setLoadingTransport(false);
      } else {
        setLoadingTransport(true);
      }
      try {
        const response = await fetch(
          `https://api.mirai.healthcare/api/transport/manage-transport/transport-student`,
          { headers: { "x-auth": `${authtoken}` } }
        );
        const data = await response.json();
        setTransportData(data);
        if (data.status) {
          setCachedData(cacheKey, data);
        }
      } catch (error) {
        console.error("Error fetching transport data:", error);
      } finally {
        setLoadingTransport(false);
      }
    };

    fetchTransportData();
  }, [isTokenValid]);

  useEffect(() => {
    const fetchAttendanceDashboardData = async () => {
      const sessionId = StudentData?.session || StudentData?.session_id;
      if (!isTokenValid || !studentId || !sessionId) return;

      const cacheKey = `dashboard_attendance_${studentId}_${sessionId}`;
      const cached = getCachedData(cacheKey);
      if (cached) {
        setAttendanceSummaryData(cached.summary);
        setTransportAttendanceSummaryData(cached.transportSummary);
        setTodayAttendanceStatus(cached.todayStatus);
        setTodayLateInTime(cached.todayLateInTime || null);
        setTodayEventAttendance(cached.todayEventAttendance || []);
        setTodayTransportAttendanceStatus(cached.todayTransportStatus);
        setCachedData('dashboard_attendance_summary', cached.summary);
        setCachedData('dashboard_transport_summary', cached.transportSummary);
        setCachedData('dashboard_today_attendance', cached.todayStatus);
        setCachedData('dashboard_today_event_attendance', cached.todayEventAttendance || []);
        setCachedData('dashboard_today_transport', cached.todayTransportStatus);
      }

      const matchedSession = Array.isArray(Session?.data)
        ? Session.data.find((s) => s.Is_Current_Session === true || s.is_current === true || s.is_current_session === true) ||
        Session.data.find((s) => Number(s.id) === Number(sessionId))
        : null;

      const activeSessionId = matchedSession?.id || sessionId;

      const rawStartDate =
        matchedSession?.Start_Date ||
        matchedSession?.start_date ||
        matchedSession?.session_start_date ||
        StudentData?.session_start_date ||
        StudentData?.session_details?.Start_Date ||
        GetstudentData?.session_start_date;

      const getFormattedDate = (dateStr) => {
        if (!dateStr) return null;
        if (typeof dateStr === "string") {
          const trimmed = dateStr.trim();
          const ddmmyyyyMatch = trimmed.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
          if (ddmmyyyyMatch) {
            const [, day, month, year] = ddmmyyyyMatch;
            return `${year}-${month}-${day}`;
          }
          if (trimmed.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return trimmed;
          }
          if (trimmed.includes("T")) {
            return trimmed.split("T")[0];
          }
        }
        const parsed = new Date(dateStr);
        return !isNaN(parsed.getTime()) ? parsed.toISOString().split("T")[0] : null;
      };

      const currentYear = new Date().getFullYear();
      const sessionStartDate = getFormattedDate(rawStartDate) || `${currentYear}-01-01`;
      const fromDate = sessionStartDate;
      const toDate = `${currentYear}-12-31`;
      const todayDate = new Date().toISOString().split("T")[0];

      let summary = null;
      let transportSummary = null;
      let todayStatus = 'not-marked';
      let todayTransportStatus = 'not-marked';

      try {
        const response = await axios.get(
          "https://api.mirai.healthcare/api/attendance/StudentAttendance/filter-data",
          {
            params: {
              session_id: activeSessionId,
              student_id: studentId,
              from_date: fromDate,
              to_date: todayDate,
            },
            headers: { "x-auth": authtoken },
          }
        );
        if (response?.data?.success) {
          summary = response?.data?.data || null;
          setAttendanceSummaryData(summary);
          setCachedData('dashboard_attendance_summary', summary);
        }
      } catch (error) {
        console.error("Error fetching attendance dashboard summary:", error);
      }

      try {
        const response = await axios.get(
          "https://api.mirai.healthcare/api/attendance/transportAttendance/transport-attendences-count",
          {
            params: {
              student_id: studentId,
              from_date: fromDate,
              to_date: todayDate,
            },
            headers: { "x-auth": authtoken },
          }
        );
        const tData = response?.data?.transport_attendance || response?.data?.data || null;
        transportSummary = tData;
        setTransportAttendanceSummaryData(tData);
        setCachedData('dashboard_transport_summary', tData);
      } catch (error) {
        console.error("Error fetching transport attendance summary:", error);
      }

      let todayEventAtt = [];
      let todayLate = null;
      try {
        const response = await axios.get(
          "https://api.mirai.healthcare/api/attendance/StudentAttendance/date-wise",
          {
            params: {
              session_id: activeSessionId,
              student_id: studentId,
              from_date: todayDate,
              to_date: todayDate,
            },
            headers: { "x-auth": authtoken },
          }
        );
        const todayRecord = Array.isArray(response?.data?.data) ? response.data.data[0] : null;
        todayStatus = todayRecord?.status || "not-marked";
        todayEventAtt = Array.isArray(todayRecord?.event_attendance) ? todayRecord.event_attendance : [];
        const schoolTimings = await fetchSchoolTimings(authtoken);
        todayLate = getLateInTime(todayRecord, schoolTimings, activeSessionId);
        setTodayAttendanceStatus(todayStatus);
        setTodayLateInTime(todayLate);
        setCachedData('dashboard_today_late_in_time', todayLate);
        setTodayEventAttendance(todayEventAtt);
        setCachedData('dashboard_today_attendance', todayStatus);
        setCachedData('dashboard_today_event_attendance', todayEventAtt);
      } catch (error) {
        console.error("Error fetching today's attendance:", error);
      }

      try {
        const response = await axios.get(
          "https://api.mirai.healthcare/api/attendance/transportAttendance/login-student",
          {
            params: {
              student_id: studentId,
              from_date: todayDate,
              to_date: todayDate,
            },
            headers: { "x-auth": authtoken },
          }
        );
        const records = response?.data?.transport_attendance || response?.data?.data || [];
        const todayRecord = Array.isArray(records) ? records[0] : null;
        todayTransportStatus = todayRecord?.status || "not-marked";
        setTodayTransportAttendanceStatus(todayTransportStatus);
        setCachedData('dashboard_today_transport', todayTransportStatus);
      } catch (error) {
        console.error("Error fetching today's transport attendance:", error);
      }

      setCachedData(cacheKey, {
        summary,
        transportSummary,
        todayStatus,
        todayLateInTime: todayLate,
        todayEventAttendance: todayEventAtt,
        todayTransportStatus
      });
    };

    fetchAttendanceDashboardData();
  }, [isTokenValid, studentId, StudentData, Session, GetstudentData]);

  // Booked events power the tracking card even when no event attendance exists
  // for today yet.
  useEffect(() => {
    const fetchEventBookings = async () => {
      const token = authtoken || localStorage.getItem("token");
      const currentStudentId = studentId || StudentData?.id || GetstudentData?.id || localStorage.getItem("dashboard_student_id") || localStorage.getItem("student_id");
      if (!token || !currentStudentId) return;

      const cacheKey = `dashboard_event_bookings_${currentStudentId}`;
      const cached = getCachedData(cacheKey);
      if (Array.isArray(cached) && cached.length > 0) {
        setEventBookings(cached);
      }

      try {
        const res = await axios.get(
          `https://api.mirai.healthcare/api/student-details/event-booking/student?student_id=${currentStudentId}`,
          { headers: { "x-auth": token } }
        );
        const payload = res?.data;
        const bookings = extractEventBookingsPayload(payload);
        setEventBookings(bookings);
        setCachedData(cacheKey, bookings);
        setCachedData('dashboard_event_bookings', bookings);
        console.log(bookings, "event bookings for dashboard");
      } catch (error) {
        console.error("Error fetching event bookings:", error);
      }
    };

    fetchEventBookings();

    const handleFocus = () => {
      fetchEventBookings();
    };
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [studentId, StudentData, GetstudentData, authtoken]);

  const sessionId =
    GetstudentData?.session ||
    StudentData?.session ||
    StudentData?.session_id ||
    GetstudentData?.session_id;

  const classSectionId =
    GetstudentData?.class_section_id ||
    StudentData?.class_section_id ||
    GetstudentData?.cls_sec_id ||
    StudentData?.cls_sec_id ||
    GetstudentData?.cls_sec?.id ||
    StudentData?.cls_sec?.id;

  const [holidayCalendar, setHolidayCalendar] = useState([]);

  useEffect(() => {
    if (tokenExpired) {
      return;
    }

    const fetchHolidayCalendar = async () => {
      if (!sessionId || !classSectionId) return;
      const cacheKey = `dashboard_holiday_calendar_${sessionId}_${classSectionId}`;
      const cached = getCachedData(cacheKey);
      if (cached) {
        setHolidayCalendar(cached);
      }
      try {
        const response = await axios.get(
          `https://api.mirai.healthcare/api/masters/holidaycalender`,
          {
            params: {
              session_id: sessionId,
              class_section_id: classSectionId,
            },
            headers: {
              "x-auth": authtoken,
            },
          }
        );

        if (response?.data?.success) {
          const hData = response?.data?.data || [];
          setHolidayCalendar(hData);
          setCachedData(cacheKey, hData);
        } else {
          setHolidayCalendar([]);
        }
      } catch (error) {
        console.error("Error fetching holiday calendar:", error);
        setHolidayCalendar([]);
      }
    };

    fetchHolidayCalendar();
  }, [sessionId, classSectionId, tokenExpired]); // ✅ IMPORTANT dependency

  // Events list for the student - used to flag the Events tab when a new event
  // is added that the parent has not opened yet (see utils/newEvents).
  const eventsStudentId = studentId || StudentData?.id || GetstudentData?.id;
  const [hasNewEvents, setHasNewEvents] = useState(false);

  useEffect(() => {
    if (tokenExpired || !eventsStudentId || !classSectionId) return;

    const fetchEventsForBadge = async () => {
      const cacheKey = `events_${eventsStudentId}_${classSectionId}`;
      const cached = getCachedData(cacheKey);
      if (cached) {
        setHasNewEvents(hasUnseenEvents(eventsStudentId, cached));
      }
      try {
        const response = await axios.get(
          `https://api.mirai.healthcare/api/student-details/event-ctgry/student?student_id=${eventsStudentId}&cls_sec_id=${classSectionId}`,
          { headers: { "x-auth": authtoken } }
        );
        if (response?.data?.success) {
          const data = response.data.message || [];
          setCachedData(cacheKey, data);
          setHasNewEvents(hasUnseenEvents(eventsStudentId, data));
        }
      } catch (error) {
        console.error("Error fetching events for new-event badge:", error);
      }
    };

    fetchEventsForBadge();
  }, [eventsStudentId, classSectionId, tokenExpired, authtoken]);

  const handleNotificationClick = (notificationData) => {
    if (!notificationData) return;

    const notifiableType = (notificationData.notifiable_type || notificationData.type || "").toLowerCase();
    const notifiableId = notificationData.notifiable_id || notificationData.id;
    const moduleId = Number(notificationData.module_id ?? notificationData.module ?? notificationData.moduleId);

    if (notifiableType === "notice" || notifiableType === "schoolnotice") {
      navigate(`/SchoolNotice?notifiable_type=${notifiableType}&notifiable_id=${notifiableId}`, {
        state: { notifiable_type: notifiableType, notifiable_id: notifiableId, data: notificationData }
      });
      return;
    }

    if (notifiableType === "homework") {
      navigate(`/HomeWork?notifiable_type=${notifiableType}&notifiable_id=${notifiableId}`, {
        state: { notifiable_type: notifiableType, notifiable_id: notifiableId, data: notificationData }
      });
      return;
    }

    if (notifiableType === "userobservation") {
      navigate(`/userobservation?notifiable_type=${notifiableType}&notifiable_id=${notifiableId}`, {
        state: { notifiable_type: notifiableType, notifiable_id: notifiableId, data: notificationData }
      });
      return;
    }

    if (notifiableType === "event" || notifiableType === "event_booking" || moduleId === 10) {
      navigate(`/events`, {
        state: { data: notificationData }
      });
      return;
    }

    if (notifiableType === "transport" || notifiableType === "bus" || moduleId === 9) {
      navigate(`/transport-details`, {
        state: { data: notificationData }
      });
      return;
    }

    if (notifiableType === "timetable" || notifiableType === "time_table" || moduleId === 7) {
      navigate(`/timetable`, {
        state: { data: notificationData }
      });
      return;
    }

    if (notifiableType === "visitor" || moduleId === 3) {
      navigate(`/visitor`, {
        state: { data: notificationData }
      });
      return;
    }

    if (
      moduleId === 16 ||
      notifiableType === "fee" ||
      notifiableType === "feecollection" ||
      notifiableType === "fee_collection" ||
      (notificationData.notification || "").toLowerCase().includes("fee") ||
      (notificationData.body || "").toLowerCase().includes("fee received")
    ) {
      navigate(routes.FeeCollection || `/FeeCollection`, {
        state: { data: notificationData }
      });
      return;
    }

    if (moduleId === 8) {
      navigate(`/SchoolNotice`, {
        state: { data: notificationData }
      });
      return;
    }

    // Default fallback to Information page
    navigate(routes.information || `/information`, {
      state: {
        moduleId: moduleId || null,
        notificationId: notifiableId,
        notification: notificationData,
        id: moduleId || null,
        label: notificationData.title || notificationData.notification || "Notification Details"
      }
    });
  };

  const checkTodayHoliday = (holidays) => {
    if (!Array.isArray(holidays) || holidays.length === 0) return null;
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const today = `${year}-${month}-${day}`;

    return holidays.find((item) => {
      if (!item?.start_date || !item?.end_date || item?.is_deleted) return false;
      const start = item.start_date.split("T")[0];
      const end = item.end_date.split("T")[0];

      return today >= start && today <= end;
    });
  };

  const todayHoliday = checkTodayHoliday(holidayCalendar);

  if (tokenExpired) {
    return null;
  }

  if (!hasToken) {
    const publicHighlights = [
      { label: "Founded", value: schoolInfo?.established_year || "Since 2000" },
      { label: "Students", value: schoolInfo?.studentCount || "1,000+" },
      {
        label: "Programs",
        value: schoolInfo?.programs_offered || "Academics & Activities",
      },
    ];

    return (
      <>
        <div className="public-dashboard">
          <Header />
          <section
            className={`public-hero ${schoolInfo?.schoolImage ? "public-hero--image" : ""
              }`}
            style={
              schoolInfo?.schoolImage
                ? { backgroundImage: `url(${schoolInfo.schoolImage})` }
                : undefined
            }
          >
            <div className="public-hero-overlay" />
            <div className="public-hero-content">
              {schoolInfo?.schoolLogo && (
                <img
                  src={schoolInfo.schoolLogo}
                  alt={schoolInfo?.schoolName || "School Logo"}
                  className="public-hero-logo"
                />
              )}
              <p className="public-hero-kicker">Welcome to</p>
              <h1 className="hero-title fw-bold">
                <span
                  className="px-3 py-1 rounded text-white"
                  style={{ backgroundColor: "#384973ff" }}
                >
                  {schoolInfo?.schoolName || ""}
                </span>
              </h1>

              <p className="public-hero-subtitle">
                {schoolInfo?.aboutUs ||
                  "Manage admissions, stay informed, and connect with your school community in one place."}
              </p>

              {/* <div className="public-hero-stats">
                {publicHighlights.map((stat, index) => (
                  <div key={`public-stat-${index}`}>
                    <span>{stat.label}</span>
                    <strong>{stat.value}</strong>
                  </div>
                ))}
              </div> */}
            </div>
          </section>
          <section className="container my-4">
            <div className="row g-4">
              {/* Stay Updated */}
              {/* <div className="col-12 col-md-6 col-lg-4">
      <div className="card shadow-sm border-0 rounded-4 h-100 p-3">
        <div className="card-body">
          <h4 className="fw-bold mb-3">Stay Updated</h4>
          <p className="text-muted">
            Track application progress, download circulars, and receive instant alerts from your school dashboard.
          </p>
        </div>
      </div>
    </div> */}

              {/* Contact */}
              <div className="col-12 col-md-6 col-lg-4 mx-auto">
                <div className="card shadow-sm border-0 rounded-4 h-100 p-3">
                  <div className="card-body">
                    <h4 className="fw-bold mb-3">Contact</h4>

                    <dl className="row mb-0">
                      <dt className="col-4 text-muted">Principal Name</dt>
                      <dd className="col-8">
                        {schoolInfo?.principalName || ""}
                      </dd>

                      <dt className="col-4 text-muted">Email</dt>
                      <dd className="col-8">
                        {schoolInfo?.email || schoolInfo?.contact_email || ""}
                      </dd>

                      <dt className="col-4 text-muted">Phone</dt>
                      <dd className="col-8">
                        {schoolInfo?.contact_number || schoolInfo?.phone || ""}
                      </dd>

                      <dt className="col-4 text-muted">Address</dt>
                      <dd className="col-8">
                        {schoolInfo?.schoolAddress ||
                          "Reach out to your school administrator for details."}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>

              {/* Highlights */}
              {/* <div className="col-12 col-md-6 col-lg-4">
      <div className="card shadow-sm border-0 rounded-4 h-100 p-3">
        <div className="card-body">
          <h4 className="fw-bold mb-3">Highlights</h4>
          <ul className="text-muted mb-0">
            <li>Confirm admissions and pay fees online</li>
            <li>View transport, attendance, and timetable updates</li>
            <li>Download certificates and academic resources anytime</li>
          </ul>
        </div>
      </div>
    </div> */}
            </div>
          </section>
        </div>
        <style jsx>{`
          .public-dashboard {
            min-height: 100vh;
            background: #f5f7fb;
          }
          .public-hero {
            position: relative;
            min-height: 70vh;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3rem 1.5rem;
            background: linear-gradient(135deg, #1e3c72, #2a5298);
            color: #fff;
            text-align: center;
          }
          .public-hero--image {
            background-size: cover;
            background-position: center;
          }
          .public-hero-overlay {
            position: absolute;
            inset: 0;
            background: rgba(15, 23, 42, 0.78);
          }
          .public-hero-content {
            position: relative;
            max-width: 780px;
            z-index: 2;
          }
          .public-hero-logo {
            max-height: 90px;
            margin-bottom: 1.25rem;
            object-fit: contain;
          }
          .public-hero-kicker {
            letter-spacing: 0.2em;
            font-size: 0.85rem;
            text-transform: uppercase;
            opacity: 0.85;
            margin-bottom: 0.5rem;
          }
          .public-hero-title {
            font-size: clamp(2rem, 5vw, 3.5rem);
            margin-bottom: 0.8rem;
          }
          .public-hero-subtitle {
            font-size: 1.05rem;
            opacity: 0.9;
          }
          .public-hero-actions {
            margin-top: 1.5rem;
            display: flex;
            justify-content: center;
            gap: 0.75rem;
            flex-wrap: wrap;
          }
          .public-hero-stats {
            margin-top: 2rem;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
            gap: 1rem;
          }
          .public-hero-stats div {
            background: rgba(255, 255, 255, 0.15);
            padding: 0.9rem;
            border-radius: 12px;
          }
          .public-hero-stats span {
            display: block;
            font-size: 0.75rem;
            text-transform: uppercase;
            letter-spacing: 0.08em;
            opacity: 0.85;
          }
          .public-hero-stats strong {
            font-size: 1.2rem;
            display: block;
            margin-top: 0.25rem;
          }
          .public-details {
            margin-top: -3rem;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            gap: 1.5rem;
            padding-bottom: 2rem;
          }
          .public-card {
            background: #fff;
            border-radius: 20px;
            padding: 1.8rem;
            box-shadow: 0 15px 30px rgba(15, 23, 42, 0.08);
          }
          .public-card dl div {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.5rem;
          }
          .public-card ul {
            margin: 0;
            padding-left: 1.1rem;
          }
          @media (max-width: 576px) {
            .public-hero {
              padding: 2.5rem 1rem;
            }
            .public-details {
              margin-top: 1.5rem;
              padding: 0 1rem 2rem;
            }
            .public-card dl div {
              flex-direction: column;
              align-items: flex-start;
            }
          }
        `}</style>
      </>
    );
  }

  // if (userType === 2) {
  //   return <Staff />;
  // }

  const appliedDate = Dashboarddata?.data?.registrationDetails?.appliedDate;
  const RegistrationStatus = getRegistration?.data?.pri_application_status;
  console.log(RegistrationStatus, "RegistrationStatus");

  const formattedStatus = RegistrationStatus?.replace(/_/g, " ");
  const RemarkTest = Dashboarddata?.data?.registrationDetails?.remark;

  const formattedDate = appliedDate
    ? new Date(appliedDate).toISOString().split("T")[0]
    : "N/A";

  const notFilledFields = Object.entries(
    Dashboarddata?.data?.studentFieldStatus || {}
  )
    .filter(([_, fieldData]) => fieldData?.isFilled === false)
    .map(([fieldName]) => fieldName);

  const MedicalnotFilledFields = Object.entries(
    Dashboarddata?.data?.studentMedicalFieldStatus || {}
  )
    .filter(([_, fieldData]) => fieldData?.isFilled === false)
    .map(([fieldName]) => fieldName);

  const StudentMobilePayment =
    getRegistration?.data?.father_mobile_no ||
    getRegistration?.data?.mother_mobile_no ||
    getRegistration?.data?.guardian_mobile_no;
  const StudentEmailPayment =
    getRegistration?.data?.father_email ||
    getRegistration?.data?.mother_email ||
    getRegistration?.data?.guardian_email;

  const schema = userData?.currentUser?.schema;

  const generateJwtToken = (schema) => {
    const header = { alg: "HS256", typ: "JWT" };
    const payload = {
      schema: schema,
      exp: Math.floor(Date.now() / 1000) + 30 * 60,
    };
    const sHeader = JSON.stringify(header);
    const sPayload = JSON.stringify(payload);
    const token = KJUR.jws.JWS.sign("HS256", sHeader, sPayload, "token");
    return token;
  };

  const handleOnlinePayment = () => {
    if (!getRegistration?.data?.id || !schema) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Missing registration ID or schema",
      });
      return;
    }

    const paymentData = {
      registrationId: getRegistration?.data?.id,
      schema: schema,
      amount: schoolInfo?.registration_fee,
      firstname: getRegistration?.data?.student_full_name,
      email: StudentEmailPayment,
      phone: StudentMobilePayment,
    };

    // console.log(paymentData, "paymentData Print")

    const base64Data = btoa(JSON.stringify(paymentData));
    const jwtToken = generateJwtToken(schema);
    // console.log(jwtToken, "jwtToken print");
    // console.log(base64Data, "base64Data Print")
    const queryParams = new URLSearchParams({
      data: base64Data,
      authToken: jwtToken,
    });

    // console.log(paymentData, "paymentData Payment")
    const paymentUrl = `https://admin.mirai.healthcare/pay-u-payment?${queryParams.toString()}`;
    // const paymentUrl = ${window.location.origin}/pay-u-payment?${queryParams.toString()};
    window.open(paymentUrl, "_blank");
    // console.log(paymentUrl, "Payment after click paymentUrl")
  };

  const handleApplyRETest = async () => {
    const userId = getRegistration?.data?.id;
    if (!userId) {
      alert("User ID is missing!");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/register/${userId}`,
        {
          method: "PATCH",
          headers: {
            "x-auth": authtoken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ exam_status: "reexam" }),
        }
      );

      if (response.ok) {
        Swal.fire("Success", "Re-Test applied successfully!", "success");
        // navigate("/index");
        // await fetchDashboardAPI;
        // await fetchExamResultData();
        await fetchUserData();
      } else {
        Swal.fire("Error", "Failed to apply for Re-Test", "error");
      }
    } catch (error) {
      console.error("Error applying for Re-Test:", error);
    } finally {
      setLoading(false);
    }
  };

  const hasRegistration =
    Dashboarddata?.data?.registrationDetails &&
    Object.keys(Dashboarddata.data.registrationDetails).length > 0;
  const enquiryData = getenquiry?.data?.[0];
  const primaryNumber =
    PrimaryContactNumber ||
    enquiryData?.contactno ||
    enquiryData?.mother_contact_no ||
    enquiryData?.guardian_mobile_no;
  const primaryEmail = PrimaryContactEmail || enquiryData?.emailid;
  const formatDisplayDate = (value) => {
    if (!value) return "N/A";
    try {
      return new Date(value).toISOString().split("T")[0];
    } catch (err) {
      return value;
    }
  };
  const calculatePercentage = (present, total) => {
    const safePresent = Number(present) || 0;
    const safeTotal = Number(total) || 0;
    if (safeTotal <= 0) return "0%";
    return `${((safePresent / safeTotal) * 100).toFixed(2)}%`;
  };
  const formatStatusText = (status) => {
    if (!status) return "NOT MARKED";
    return String(status).replace(/_/g, " ").toUpperCase();
  };
  const formatServiceType = (type) => {
    if (!type) return "";
    const str = String(type).trim();
    const lower = str.toLowerCase();
    if (lower === "both" || lower === "pick_and_drop" || lower === "pick & drop") {
      return "pick and drop";
    }
    return str;
  };
  const getStatusMeta = (status) => {
    switch ((status || "").toLowerCase()) {
      case "present":
        return { variant: "bg-success", icon: <FaCheckCircle /> };
      case "absent":
        return { variant: "bg-danger", icon: <FaTimesCircle /> };
      case "leave":
        return { variant: "bg-warning text-dark", icon: <FaClock /> };
      default:
        return { variant: "bg-secondary", icon: <FaClock /> };
    }
  };

  const todayExitPass =
    Dashboarddata?.data?.exitPassCount?.["Today Gate Pass"]?.[0];
  const heroStats = [
    Dashboarddata?.data?.isAdmission !== true && {
      label: "Registration Status",
      value:
        formattedStatus ||
        (hasRegistration
          ? "Submitted"
          : enquiryData
            ? "In Progress"
            : "Not Started"),
    },
    {
      label: "REQUIRED FIELDS",
      value:
        (notFilledFields?.length || 0) + (MedicalnotFilledFields?.length || 0),
      isNumber: true,
    },
    Dashboarddata?.data?.isAdmission === true && {
      label: "Gate Pass (Monthly)",
      value: Dashboarddata?.data?.exitPassCount?.monthly?.monthlyCount ?? 0,
      isNumber: true,
    },
    Dashboarddata?.data?.isAdmission === true && {
      label: "Transport Assigned",
      value: loadingTransport ? "Loading..." : (hasTransport ? "Yes" : "Self"),
      isNumber: false,
      route: "/transportinfo",
    },

  ];

  const quickActions = [

    !isAdmitted && hasRegistration && {
      key: "registration",
      label: "Registration",
      description: "Review or update registration details.",
      to: "/registration",
      icon: FaClipboardList,
    },
    !isAdmitted &&
    !hasRegistration &&
    enquiryData &&
    getRegistration?.data?.length === 0 && {
      key: "apply",
      label: "Apply for Registration",
      description: "Complete registration to continue the process.",
      to: "/enquiry",
      icon: FaUserCheck,
    },
    // getRegistration?.data?.registration_fee_status === "unpaid" && {
    //   key: "RegistrationFees",
    //   label: "Registration Fees",
    //   description: "Your registration is not yet submitted. Please make your payment online or at the school to finalize your registration.",
    //   to: "/",
    //   icon: FaMoneyBillWave,
    // },

    Dashboarddata?.data?.isAdmission === true && {
      key: "fees",
      label: "Fees & Payments",
      description: "Check fee history and pay dues instantly.",
      to: "/FeeCollection",
      icon: FaMoneyBillWave,
    },
    schoolInfo?.feeStructure && {
      key: "documents",
      label: "Documents",
      description: "Download shared documents from school.",
      to: "/documentdownload",
      icon: FaFileAlt,
    },
    TransportData?.data?.length > 0 && {
      key: "transport",
      label: "Transport Tracking",
      description: "Track your assigned route and live transport updates.",
      to: "/transportinfo",
      state: { transportData: TransportData },
      icon: FaBus,
    },
    // TransportData?.data?.length > 0 && {
    //   key: "transport-attendance",
    //   label: "Transport Attendance",
    //   description: "View transport attendance summary and history.",
    //   to: "/attendancetransport",
    //   icon: FaBus,
    // },
    Dashboarddata?.data?.isAdmission === true && {
      key: "attendance",
      label: "Attendance",
      description: "View attendance history and percentage.",
      to: "/attendance",
      icon: FaRegCalendarCheck,
    },
    // Dashboarddata?.data?.BookEntrance === true && {
    //   key: "exam",
    //   label: "Entrance Exam",
    //   description: "Book or review your exam slot.",
    //   to: "/examschedule",
    //   icon: FaRegCalendarCheck,
    // },
    !isAdmitted &&
    getRegistration?.data?.registration_fee_status === "paid" &&
    Dashboarddata?.data?.BookEntrance === true && {
      key: "exam",
      label: "Entrance Exam",
      description: "Book or review your exam slot.",
      to: "/examschedule",
      icon: FaRegCalendarCheck,
    },
  ].filter(Boolean);

  const infoTiles = [];
  const addTile = (tile) => {
    if (tile) infoTiles.push(tile);
  };

  if (primaryNumber || primaryEmail) {
    addTile({
      key: "primary-contact",
      eyebrow: "Stay connected",
      title: "Primary Contact Details",
      rows: [
        { label: "Mobile No.", value: primaryNumber || "N/A" },
        { label: "Email", value: primaryEmail || "N/A" },
      ],
    });
  }
  if (!isAdmitted && !hasRegistration && enquiryData && getRegistration?.data?.length === 0) {
    // if (!hasRegistration && enquiryData) {
    addTile({
      key: "enquiry",
      eyebrow: "Application started",
      title: "Enquiry Details",
      rows: [
        { label: "Student", value: enquiryData?.student_full_name },
        { label: "Class", value: enquiryData?.class_data?.Classes },
        { label: "Session", value: enquiryData?.session_data?.Name },
      ],
      actions: [
        {
          label: "Enquiry Details",
          to: "/enquiry",
          variant: "btn-primary",
        },
      ],
    });
  }

  if (!isAdmitted && enquiryData?.is_bonafied === true) {
    addTile({
      key: "bonafide",
      eyebrow: "Document required",
      title: "Bonafide Certificate",
      description:
        "Please submit your Bonafide certificate at the time of registration.",
      actions: [
        {
          label: "View Details",
          to: "/createregistration",
        },
      ],
    });
  }

  if (!isAdmitted && enquiryData?.is_pen === true) {
    addTile({
      key: "pen",
      eyebrow: "Document required",
      title: "PEN Required",
      description:
        "Submit the Permanent Education Number (PEN) certificate during registration.",
      actions: [
        {
          label: "View Details",
          to: "/createregistration",
        },
      ],
    });
  }

  if (!isAdmitted && getRegistration?.data?.registration_fee_status === "unpaid") {
    const statusVariant =
      RegistrationStatus === "Validate"
        ? "bg-success"
        : RegistrationStatus === "Action_Required"
          ? "bg-danger"
          : "bg-warning text-dark";
    const registrationActions = [
      getRegistration?.data?.registration_fee_status === "unpaid" && {
        label: "Pay Registration Fee",
        variant: "btn-primary",
        onClick: handleOnlinePayment,
      },
    ].filter(Boolean);
    addTile({
      key: "registration-details",
      eyebrow: "Application progress",
      title: "Registration Fees",
      badge: {
        label: formattedStatus || "Pending",
        variant: statusVariant,
      },

      description:
        "Your registration is not yet submitted. Please make your payment online or at the school to finalize your registration.",
      actions: registrationActions,
    });
  }

  if (!isAdmitted && hasRegistration) {
    const statusVariant =
      RegistrationStatus === "Validate"
        ? "bg-success"
        : RegistrationStatus === "Action_Required"
          ? "bg-danger"
          : "bg-warning text-dark";
    const registrationActions = [
      {
        label: "View Details",
        to: "/registration",
        variant: "btn-primary",
      },
      // getRegistration?.data?.registration_fee_status === "unpaid" && {
      //   label: "Pay Registration Fee",
      //   onClick: handleOnlinePayment,
      // },
      getRegistration?.data?.registration_fee_status === "paid" && {
        label: "Admission Form",
        to: "/admissionform",
        target: "_blank",
        variant: "btn-outline-secondary",
      },
    ].filter(Boolean);
    addTile({
      key: "registration-details",
      eyebrow: "Application progress",
      title: "Registration Details",
      badge: {
        label: formattedStatus || "Pending",
        variant: statusVariant,
      },
      rows: [
        {
          label: "Student",
          value:
            Dashboarddata?.data?.registrationDetails?.student_name ||
            enquiryData?.student_full_name,
        },
        { label: "Applied Date", value: formatDisplayDate(appliedDate) },
      ],
      description: RemarkTest,
      actions: registrationActions,
    });
  }


  if (Dashboarddata?.data?.documentRequired?.isRequired === false) {
    addTile({
      key: "document-required",
      title: "Document Required",
      description:
        Dashboarddata?.data?.documentRequired?.remark ||
        "Additional documents are needed.",
      actions: [
        {
          label: "View Details",
          to: "/specialdocument",
        },
      ],
    });
    //     addTile({
    //   key: "document-required",
    //   title: "Document Required",
    //   description:
    //     Dashboarddata?.data?.documentRequired?.remark ||
    //     "Additional documents are needed.",
    //   actions: [
    //     {
    //       label: "View Details",
    //       to: {
    //         pathname: "/specialdocument",
    //         state: { registrationId: userId }, // <-- pass here
    //       },
    //     },
    //   ],
    // });
  }

  if (Dashboarddata?.data?.officeVisitRequired?.isRequired === true) {
    addTile({
      key: "office-visit",
      title: "Office Visit Required",
      description:
        Dashboarddata?.data?.officeVisitRequired?.remark ||
        "Please visit school office for further assistance.",
      actions: [
        {
          label: "View Details",
          to: "/visitor",
        },
      ],
    });
  }

  // if (Dashboarddata?.data?.BookEntrance === true) {
  //   addTile({
  //     key: "exam-schedule",
  //     title: "Entrance Exam Schedule",
  //     description: "Book your entrance exam slot to secure admission.",
  //     actions: [
  //       {
  //         label: "Book Exam",
  //         to: "/examschedule",
  //         variant: "btn-primary",
  //       },
  //     ],
  //   });
  // }

  if (
    !isAdmitted &&
    getRegistration?.data?.registration_fee_status === "paid" &&
    Dashboarddata?.data?.BookEntrance === true
  ) {
    addTile({
      key: "exam-schedule",
      title: "Entrance Exam Schedule",
      description: "Book your entrance exam slot to secure admission.",
      actions: [
        {
          label: "Book Exam",
          to: "/examschedule",
          variant: "btn-primary",
        },
      ],
    });
  }

  if (!isAdmitted && Dashboarddata?.data?.registrationDetails?.examStatus === "fail") {
    addTile({
      key: "Re-exam",
      title: "Re-Exam Schedule",
      description: "Book your re-exam slot to secure admission.",
      actions: [
        {
          label: "Apply for Re-Test",
          variant: "btn-primary",
          onClick: handleApplyRETest      // ← यही main point
        }
      ],
    });
  }


  // if (Dashboarddata?.data?.examResults?.length > 0) {
  // if (Dashboarddata?.data?.interviewStatus) {
  //   addTile({
  //     key: "exam-result",
  //     title: "Entrance Exam Result",
  //     description: "School Intraction status {Dashboarddata?.data?.interviewStatus}",
  //     actions: [
  //       { label: "View Result", to: "/entranceresult", variant: "btn-primary" },
  //     ],
  //   });
  // }

  if (!isAdmitted && Dashboarddata?.data?.interviewStatus) {
    const status = Dashboarddata?.data?.interviewStatus;

    const getColor = () => {
      if (status === "Approved") return "green";
      if (status === "Pending") return "orange";
      if (status === "Rejected") return "red";
      return "black";
    };

    addTile({
      key: "exam-result",
      title: "Entrance Exam Result",
      description: (
        <>
          School Interaction Status:{" "}
          <span style={{ color: getColor(), fontWeight: 600 }}>{status}</span>
        </>
      ),
      actions: [
        { label: "View Result", to: "/entranceresult", variant: "btn-primary" },
      ],
    });
  }

  if (!isAdmitted && Dashboarddata?.data?.interviewDay) {

    addTile({
      key: "interview-day",
      title: "Interview Schedule",
      rows: [
        {
          label: "Schedule",
          value: Dashboarddata?.data?.interviewDay?.lable || "N/A",
        },
      ],
      actions: [
        { label: "View Details", to: "/examinterview", variant: "btn-primary" },
      ],
    });
  }

  if (Dashboarddata?.data?.studentInterview) {
    addTile({
      key: "student-interview",
      title: "Student Interview",
      rows: [
        {
          label: "Date",
          value: Dashboarddata?.data?.studentInterview?.date || "N/A",
        },
        {
          label: "Start Time",
          value: Dashboarddata?.data?.studentInterview?.start_time || "N/A",
        },
        {
          label: "End Time",
          value: Dashboarddata?.data?.studentInterview?.end_time || "N/A",
        },
      ],
    });
  }

  if (Dashboarddata?.data?.due_fee?.is_show_due_fee === true) {
    addTile({
      key: "due-fee",
      title: "Fee Due",
      description:
        "You have an outstanding fee. Please clear dues to continue the process.",
      actions: [
        { label: "Pay Now", to: "/FeeCollection", variant: "btn-primary" },
      ],
    });
  }

  if (Dashboarddata?.data?.exitPassCount) {
    addTile({
      key: "exit-pass",
      title: "Exit Pass Summary",
      rows: [
        {
          label: "This Month",
          value: Dashboarddata?.data?.exitPassCount?.monthly?.monthlyCount || 0,
        },
        {
          label: "Overall",
          value: Dashboarddata?.data?.exitPassCount?.overall?.overallCount || 0,
        },
      ],
    });
  }

  if (todayExitPass) {
    addTile({
      key: "exit-pass-today",
      title: "Today Exit Pass",
      rows: [
        { label: "Guardian", value: todayExitPass?.guardian_name },
        { label: "Contact", value: todayExitPass?.guardian_mobile_no },
        { label: "Relation", value: todayExitPass?.accompanied_by },
        { label: "Date", value: formatDisplayDate(todayExitPass?.date) },
        { label: "Status", value: todayExitPass?.status },
      ],
    });
  }

  if (
    Dashboarddata?.data?.suspended?.isCurrentlySuspended === true &&
    Dashboarddata?.data?.suspended
  ) {
    addTile({
      key: "suspended",
      title: "Suspension Notice",
      description:
        Dashboarddata?.data?.suspended?.remark ||
        "Your account is currently suspended. Contact the school for details.",
    });
  }

  if (notFilledFields?.length > 0) {
    addTile({
      key: "documents-info",
      title: "Documents Pending",
      description: "Please upload the following pending documents.",
      tags: notFilledFields,
      actions: [{ label: "Update Now", to: "/AapproveStudentInfo" }],
    });
  }

  if (MedicalnotFilledFields?.length > 0) {
    addTile({
      key: "medical-info",
      title: "Medical Info Required",
      description: "Provide the pending medical details to complete profile.",
      tags: MedicalnotFilledFields,
      actions: [{ label: "Update Medical Info", to: "/medicalinfo" }],
    });
  }

  if (
    GetstudentData?.is_admitted === false ||
    GetstudentData?.is_admitted === null
  ) {
    addTile({
      key: "admission-fee",
      title: "Admission Fees",
      description: "Submit the admission fee to confirm your seat.",
      actions: [
        {
          label: "Pay Admission Fee",
          to: "/admissionfees",
          variant: "btn-primary",
          state: {
            ctgry_id: GetstudentData?.ctgry_id,
            session: GetstudentData?.session,
          },
        },
      ],
    });
  }

  // if (schoolInfo?.feeStructure) {
  //   addTile({
  //     key: "documents-download",
  //     title: "School Documents",
  //     description: "Download important documents shared by school.",
  //     actions: [
  //       { label: "Download", to: "/documentdownload", variant: "btn-primary" },
  //     ],
  //   });
  // }

  const totalDays = Number(attendanceSummaryData?.totalDays) || 0;
  const presentDays = Number(attendanceSummaryData?.present) || 0;
  const absentDays = Number(attendanceSummaryData?.absent) || 0;
  const leaveDays = Number(attendanceSummaryData?.leave) || 0;
  const suspendDays = Number(attendanceSummaryData?.suspend) || 0;
  const NotMarksDays = Number(attendanceSummaryData?.notMark) || 0;
  const markedDays = presentDays + absentDays + leaveDays;

  const apiAttendancePercentage =
    attendanceSummaryData?.attendancePercentage ??
    attendanceSummaryData?.attendance_percentage;

  const attendancePercentage =
    apiAttendancePercentage !== undefined && apiAttendancePercentage !== null
      ? (String(apiAttendancePercentage).endsWith("%")
        ? apiAttendancePercentage
        : `${apiAttendancePercentage}%`)
      : (markedDays
        ? `${((presentDays / markedDays) * 100).toFixed(2)}%`
        : "0%");

  // School's minimum required attendance; below it the percentage is shown in red
  const minAttendance = parseFloat(schoolInfo?.min_attendance);
  const isBelowMinAttendance =
    !isNaN(minAttendance) && parseFloat(attendancePercentage) < minAttendance;

  const tTotalDays = Number(transportAttendanceSummaryData?.totalDays) || 0;
  const tPresentDays = Number(transportAttendanceSummaryData?.present) || 0;
  const tAbsentDays = Number(transportAttendanceSummaryData?.absent) || 0;
  const tLeaveDays = Number(transportAttendanceSummaryData?.leave) || 0;
  const tMarkedDays = tPresentDays + tAbsentDays + tLeaveDays;

  const apiTAttendancePercentage =
    transportAttendanceSummaryData?.attendancePercentage ??
    transportAttendanceSummaryData?.attendance_percentage;

  const tAttendancePercentage =
    apiTAttendancePercentage !== undefined && apiTAttendancePercentage !== null
      ? (String(apiTAttendancePercentage).endsWith("%")
        ? apiTAttendancePercentage
        : `${apiTAttendancePercentage}%`)
      : (tMarkedDays
        ? `${((tPresentDays / tMarkedDays) * 100).toFixed(2)}%`
        : "0%");

  const firstTransportItem = TransportData?.data?.[0] || {};
  const todayDateStr = new Date().toISOString().split("T")[0];
  const todayPickupAttendance = Array.isArray(firstTransportItem?.pickup_attendance)
    ? (firstTransportItem.pickup_attendance.find((item) => item?.date?.startsWith(todayDateStr)) ||
      firstTransportItem.pickup_attendance[0])
    : null;


  const checkIsStudentSuspended = (studentObj) => {
    if (!studentObj) return false;
    const isSuspended =
      studentObj.is_suspended === true ||
      studentObj.is_suspend === true ||
      studentObj.isSuspended === true;
    if (!isSuspended) return false;

    const suspendFrom = studentObj.suspend_from;
    const suspendTo = studentObj.suspend_to;
    if (!suspendFrom || !suspendTo) return isSuspended;

    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const today = `${year}-${month}-${day}`;

    const start = String(suspendFrom).split("T")[0];
    const end = String(suspendTo).split("T")[0];

    return today >= start && today <= end;
  };

  const isStudentSuspendedToday =
    checkIsStudentSuspended(StudentData) ||
    checkIsStudentSuspended(GetstudentData);

  const formattedTodayStatus = `${formatStatusText(todayAttendanceStatus)}${todayLateInTime ? ` (LATE ${todayLateInTime})` : ""}`;

  if (attendanceSummaryData) {
    // 👉 Holiday check
    const todayHoliday = checkTodayHoliday(holidayCalendar);

    addTile({
      key: "attendance-history",
      icon: <FaCalendarCheck />,
      title: "Attendance History",

      badge: todayHoliday
        ? {
          label: `Holiday: ${todayHoliday.title}`,
          variant: "bg-warning",
          icon: <FaCalendarCheck />,
        }
        : {
          label: `Today: ${formattedTodayStatus}`,
          variant: todayLateInTime ? "bg-late late-blink" : getStatusMeta(todayAttendanceStatus).variant,
          icon: getStatusMeta(todayAttendanceStatus).icon,
        },

      rows: todayHoliday
        ? [
          {
            label: "Today Status",
            value: `Holiday (${todayHoliday.title})`,
          },
          {
            label: "Description",
            value: todayHoliday.description,
          },
        ]
        : [
          {
            label: "Today Attendance",
            value: formattedTodayStatus,
          },
          ...(todayEventAttendance && todayEventAttendance.length > 0
            ? todayEventAttendance.map((ev) => ({
              label: `Event: ${(ev.event_name || 'Event').trim()} (${ev.attendance_type || ''})`,
              value: formatStatusText(ev.status),
            }))
            : []),
          { label: "Present", value: presentDays },
          { label: "Absent", value: absentDays },
          { label: "Leave", value: leaveDays },
          ...(attendanceSummaryData?.suspend !== undefined ? [{ label: "Suspend", value: suspendDays }] : []),
          { label: "Not Marked", value: attendanceSummaryData?.notMark || 0 },
          { label: "Total Days", value: totalDays },
          {
            label: "Attendance %",
            value: attendancePercentage,
          },
        ],

      actions: [{ label: "View Attendance", to: "/attendance" }],
    });
  }

  if (TransportData?.data?.length > 0 && transportAttendanceSummaryData) {
    const totalDays = Number(transportAttendanceSummaryData?.totalDays) || 0;
    const presentDays = Number(transportAttendanceSummaryData?.present) || 0;
    const absentDays = Number(transportAttendanceSummaryData?.absent) || 0;
    const leaveDays = Number(transportAttendanceSummaryData?.leave) || 0;

    const markedDays = presentDays + absentDays + leaveDays;
    const attendancePercentage = tAttendancePercentage;

    // ✅ Holiday check
    const todayHoliday = checkTodayHoliday(holidayCalendar);

    const todayTransportStatusMeta = getStatusMeta(todayTransportAttendanceStatus);

    const pickLabel = todayPickupAttendance?.status
      ? formatStatusText(todayPickupAttendance.status)
      : formatStatusText(todayTransportAttendanceStatus);

    const dropLabel = todayPickupAttendance?.out_status
      ? formatStatusText(todayPickupAttendance.out_status)
      : null;

    const todayBadgeLabel = dropLabel
      ? `Today: Pick: ${pickLabel} | Drop: ${dropLabel}`
      : `Today: ${pickLabel}`;

    addTile({
      key: "transport-attendance-history",
      icon: <FaBusAlt />,
      title: "Transport Attendance",

      badge: todayHoliday
        ? {
          label: `Holiday: ${todayHoliday.title}`,
          variant: "bg-warning",
          icon: <FaCalendarCheck />,
        }
        : {
          label: todayBadgeLabel,
          variant: todayTransportStatusMeta.variant,
          icon: todayTransportStatusMeta.icon,
        },

      rows: todayHoliday
        ? [
          {
            label: "Today Status",
            value: `Holiday (${todayHoliday.title})`,
          },
          {
            label: "Description",
            value: todayHoliday.description,
          },
        ]
        : [
          {
            label: "Pick Status (Morning)",
            value: todayPickupAttendance?.status
              ? `${formatStatusText(todayPickupAttendance.status)}${todayPickupAttendance?.in_time ? ` (${todayPickupAttendance.in_time})` : ""}`
              : formatStatusText(todayTransportAttendanceStatus),
          },
          {
            label: "Drop Status (Evening)",
            value: todayPickupAttendance?.out_status
              ? `${formatStatusText(todayPickupAttendance.out_status)}${todayPickupAttendance?.out_time ? ` (${todayPickupAttendance.out_time})` : ""}`
              : "N/A",
          },
          { label: "Present", value: presentDays },
          { label: "Absent", value: absentDays },
          { label: "Leave", value: leaveDays },
          {
            label: "Not Marked",
            value: transportAttendanceSummaryData?.notMark || 0,
          },
          { label: "Total Days", value: totalDays },
          {
            label: "Attendance %",
            value: attendancePercentage,
          },
        ],

      actions: [
        { label: "View Transport Attendance", to: "/attendancetransport" },
      ],
    });
  }

  if (TransportData?.data && TransportData?.data?.length > 0) {
    const firstTransportRecord = TransportData?.data?.[0] || {};

    const subList = getSubstituteList(firstTransportRecord);
    const hasSubstitute = subList.length > 0;
    const firstSubUrl = subList.find(s => s?.substitute_vehicle_route_url)?.substitute_vehicle_route_url;
    const vehicleRouteUrl = (typeof firstSubUrl === 'object' ? firstSubUrl?.vehicle_route_url : firstSubUrl) || firstTransportRecord?.vehicle_details?.vehicle_route_url;

    const rows = [];

    // ✅ Main Bus Row
    rows.push({
      label: "Substitute Bus No.",
      value: hasSubstitute ? (
        <div className="d-flex flex-column gap-1">
          {subList.map((subItem, idx) => (
            <div key={idx} className="mb-1">
              <div className="fw-bold">
                {subItem?.substitute_vehicle_number || subItem?.vehicle_number || "N/A"}
                <span className="badge bg-success ms-2">
                  Sub{subItem?.trip ? ` (${subItem.trip})` : ''}
                </span>
              </div>
              {subItem?.substitute_date && (
                <div>
                  <span className="badge bg-info text-end" style={{ textAlign: 'right', float: 'right' }}>
                    {subItem.substitute_date}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        firstTransportRecord?.vehicle_details?.vehicle_number || "N/A"
      ),
    });

    // ✅ Only if substitute exists → show original bus (small)
    if (hasSubstitute) {
      rows.push({
        label: "Bus No.",
        value: (
          <span className="text-muted" style={{ fontSize: "11px", marginTop: '10px' }}>
            {firstTransportRecord?.vehicle_details?.vehicle_number || "N/A"}
          </span>
        ),
      });
    }

    // ✅ Other Details
    rows.push(
      {
        label: "Stop Name",
        value: firstTransportRecord?.stoppage_details?.stop_name || "N/A",
      },
      {
        label: "Service Type",
        value: (
          <span className="badge bg-secondary text-capitalize">
            {formatServiceType(firstTransportRecord?.service_type) || "N/A"}
          </span>
        ),
      }
    );

    // ✅ Add Tile
    addTile({
      key: "transport-info",
      title: "Transport Info",
      rows: rows,

      actions: [
        {
          label: "View More Details",
          to: "/transportinfo",
          state: { transportData: TransportData },
          variant: "btn-primary",
        },
        vehicleRouteUrl && {
          label: "Locate Route",
          onClick: () => {
            if (todayHoliday) {
              Swal.fire({
                icon: "info",
                title: "School Holiday Today",
                text: `Live tracking is not available today (${todayHoliday.title || 'Holiday'}).`,
                confirmButtonColor: "#3085d6",
              });
              return;
            }
            window.open(vehicleRouteUrl, "_blank", "noopener,noreferrer");
          },
          variant: "btn-outline-primary",
        },
      ].filter(Boolean),
    });
  }

  const resolveRoute = (link) => {
    if (typeof link === "string" && link.startsWith("routes.")) {
      const routeKey = link.replace("routes.", "");
      return routes[routeKey] || "/";
    }
    return link;
  };

  const getRoutePath = (link) => {
    const key = link.replace("routes.", "");
    return routes[key] || "/";
  };



  if (loading || !minTimeDone) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status" />
        {showSlowMsg && (
          <div className="text-center text-muted small mt-3 px-3" style={{ maxWidth: '300px' }}>
            ⚠️ {message}
          </div>
        )}
      </div>
    );
  }

  if (!isAdmitted) {
    return (
      <>
        <div className="page-wrapper dashboard-home">
          <Header />
          {anyUpdateAlerts.length > 0 && (
            <div className="app-update-banner-wrap">
              {anyUpdateAlerts.map((update) => (
                <div className="app-update-banner" key={update.id}>
                  <span className="app-update-banner-icon-badge">
                    <FaInfoCircle className="app-update-banner-icon" />
                  </span>
                  <div className="app-update-banner-body">
                    <div className="app-update-banner-title">Update</div>
                    <div className="app-update-banner-text">{update.message}</div>
                  </div>
                  <button
                    type="button"
                    className="app-update-banner-ok"
                    onClick={() => dismissAnyUpdateAlert(update)}
                  >
                    OK
                  </button>
                  <div
                    className="app-update-banner-timer"
                    style={{ animationDuration: `${ANY_UPDATE_ALERT_DURATION_MS}ms` }}
                  />
                </div>
              ))}
            </div>
          )}
          <section
            className={`home-hero ${schoolInfo?.schoolImage ? "home-hero--image" : ""
              }`}
            style={
              schoolInfo?.schoolImage
                ? { backgroundImage: `url(${schoolInfo.schoolImage})` }
                : undefined
            }
          >
            <div className="hero-overlay" />
            <div className="hero-content">
              <span className="hero-kicker">
                Welcome back
                {userData?.currentUser?.fname
                  ? `, ${userData.currentUser.fname}`
                  : ""}
              </span>
              <h1 className="hero-title fw-bold">
                <span
                  className="px-3 py-1 rounded text-white"
                  style={{ backgroundColor: "#384973ff" }}
                >
                  {schoolInfo?.schoolName || ""}
                </span>
              </h1>

              <p className="hero-meta">
                {userData?.currentUser?.username || ""}
              </p>

              {heroStats.length > 0 && (
                <div className="hero-stats">
                  {heroStats.map((stat, idx) => (
                    <div
                      key={idx}
                      className={`hero-stat ${stat.label === "Transport Assigned" ? "cursor-pointer" : ""
                        }`}
                      onClick={() => {
                        if (stat.label === "Transport Assigned") {
                          navigate("/transportinfo", {
                            state: { transportData: TransportData },
                          });
                        }
                      }}
                    >
                      <span>{stat.label}</span>
                      <strong>
                        {stat.isNumber ? (
                          <CountUp end={Number(stat.value) || 0} duration={1} />
                        ) : (
                          stat.value
                        )}
                      </strong>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </section>
          <div className="content home-content">
            <div className="container-fluid">
              {quickActions.length > 0 && (
                <div className="quick-actions">
                  {quickActions.map((action) => {
                    const Icon = action.icon;
                    return (
                      <Link
                        key={action.key}
                        to={action.to}
                        state={action.state}
                        className="quick-action-card"
                      >
                        <div className="quick-action-icon">
                          <Icon size={18} />
                        </div>
                        <div>
                          <h6>{action.label}</h6>
                          <p>{action.description}</p>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              )}

              <div className="info-grid">
                {infoTiles.length > 0 ? (
                  infoTiles.map((tile) => <InfoTile key={tile.key} card={tile} />)
                ) : (
                  <div className="info-empty text-center py-5">
                    <FaFileAlt size={48} className="text-muted mb-3" />
                    <h5 className="mb-1">No updates yet</h5>
                    <p className="text-muted mb-0">
                      We'll display important updates about your application here.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <style jsx>{`
          .dashboard-home {
            background-color: #f5f7fb;
          }
          .home-hero {
            position: relative;
            border-radius: 24px;
            margin: 1.5rem;
            padding: 2.5rem;
            background: linear-gradient(135deg, #1e3c72, #2a5298);
            color: #fff;
            overflow: hidden;
          }
          .home-hero--image {
            background-size: cover;
            background-position: center;
          }
          .hero-overlay {
            position: absolute;
            inset: 0;
            background: rgba(15, 23, 42, 0.65);
          }
          .hero-content {
            position: relative;
            z-index: 2;
            max-width: 800px;
          }
          .hero-kicker {
            text-transform: uppercase;
            letter-spacing: 0.18em;
            font-size: 0.75rem;
            font-weight: 600;
            display: block;
            margin-bottom: 0.5rem;
            color: rgba(255, 255, 255, 0.85);
          }
          .hero-title {
            font-size: clamp(1.6rem, 4vw, 2.6rem);
            font-weight: 700;
            margin-bottom: 0.4rem;
          }
          .hero-meta {
            font-size: 1rem;
            opacity: 0.9;
          }
          .hero-stats {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
            gap: 1rem;
            margin-top: 1.5rem;
          }
          .hero-stat {
            background: rgba(255, 255, 255, 0.12);
            padding: 0.85rem 1rem;
            border-radius: 12px;
          }
          .hero-stat span {
            display: block;
            font-size: 0.75rem;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            opacity: 0.85;
          }
          .hero-stat strong {
            font-size: 1.25rem;
            font-weight: 700;
          }
          .home-content {
            padding: 0 1.5rem 2rem;
          }
          .quick-actions {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            gap: 1rem;
            margin-bottom: 2rem;
          }
          .quick-action-card {
            text-decoration: none;
            background: #fff;
            border-radius: 16px;
            padding: 1rem 1.2rem;
            display: flex;
            gap: 0.8rem;
            align-items: center;
            border: 1px solid rgba(226, 232, 240, 0.9);
            transition: transform 0.2s ease, box-shadow 0.2s ease;
            color: #0f172a;
          }
          .quick-action-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 15px 35px rgba(15, 23, 42, 0.12);
          }
          .quick-action-icon {
            width: 42px;
            height: 42px;
            border-radius: 12px;
            background: rgba(13, 110, 253, 0.12);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0d6efd;
          }
          .quick-action-card h6 {
            margin: 0;
            font-weight: 600;
          }
          .quick-action-card p {
            margin: 0;
            font-size: 0.85rem;
            color: #64748b;
          }
          .info-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 1.25rem;
          }
          .info-card {
            background: #fff;
            border-radius: 18px;
            padding: 1.4rem;
            border: 1px solid rgba(226, 232, 240, 0.9);
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
          }
          .info-card-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 0.5rem;
          }
          .info-card-leading-icon {
            font-size: 1.55rem;
            line-height: 1;
            color: #0d6efd;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 34px;
            height: 34px;
            background: rgba(13, 110, 253, 0.12);
            border-radius: 10px;
            flex-shrink: 0;
          }
          .info-card-badge-icon {
            font-size: 0.95rem;
            line-height: 1;
            display: inline-flex;
            align-items: center;
            vertical-align: -1px;
          }
          .info-card-eyebrow {
            text-transform: uppercase;
            font-size: 0.7rem;
            letter-spacing: 0.1em;
            color: #94a3b8;
            display: block;
            margin-bottom: 0.25rem;
          }
          .info-card-title {
            margin: 0;
            font-size: 1.1rem;
            font-weight: 600;
            color: #0f172a;
          }
          .info-card-desc {
            color: #475569;
          }
          .info-card-row dt {
            font-weight: 500;
            color: #475569;
          }
          .info-card-row dd {
            margin: 0;
            font-weight: 600;
            color: #111827;
          }
          .info-card-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 0.35rem;
          }
          .info-card-actions {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;
            margin-top: 0.5rem;
          }
          .info-empty {
            grid-column: 1 / -1;
            background: #fff;
            border-radius: 16px;
          }
          @media (max-width: 768px) {
            .home-hero {
              margin: 1rem;
              padding: 1.75rem;
            }
            .hero-stats {
              grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
            }
          }
          @media (max-width: 576px) {
            .home-hero {
              margin: 0.5rem;
            }
            .home-content {
              padding: 0 1rem 1.5rem;
            }
          }
          .app-update-banner-wrap {
            position: fixed;
            top: 16px;
            right: 16px;
            z-index: 2000;
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: min(340px, calc(100vw - 32px));
          }
          .app-update-banner {
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: flex-start;
            gap: 12px;
            background: #ffffff;
            border: 1px solid #e6ecf5;
            border-left: 4px solid #2563eb;
            color: #1e293b;
            border-radius: 14px;
            padding: 14px 16px 16px;
            font-size: 13px;
            box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14), 0 2px 6px rgba(15, 23, 42, 0.06);
            animation: app-update-banner-slide-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          }
          @keyframes app-update-banner-slide-in {
            from {
              opacity: 0;
              transform: translateX(24px) scale(0.97);
            }
            to {
              opacity: 1;
              transform: translateX(0) scale(1);
            }
          }
          .app-update-banner-icon-badge {
            flex-shrink: 0;
            width: 34px;
            height: 34px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #dbeafe, #eff6ff);
          }
          .app-update-banner-icon {
            color: #2563eb;
            font-size: 16px;
          }
          .app-update-banner-body {
            flex: 1;
            min-width: 0;
            padding-top: 2px;
          }
          .app-update-banner-title {
            font-weight: 700;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: #2563eb;
            margin-bottom: 3px;
          }
          .app-update-banner-text {
            color: #334155;
            font-weight: 500;
            line-height: 1.45;
            word-break: break-word;
          }
          .app-update-banner-ok {
            flex-shrink: 0;
            border: none;
            background: linear-gradient(135deg, #2563eb, #1d4ed8);
            color: #ffffff;
            padding: 6px 16px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 700;
            letter-spacing: 0.02em;
            cursor: pointer;
            box-shadow: 0 4px 10px rgba(37, 99, 235, 0.35);
            transition: transform 0.15s ease, box-shadow 0.15s ease;
          }
          .app-update-banner-ok:hover {
            transform: translateY(-1px);
            box-shadow: 0 6px 14px rgba(37, 99, 235, 0.4);
          }
          .app-update-banner-ok:active {
            transform: translateY(0);
          }
          .app-update-banner-timer {
            position: absolute;
            left: 0;
            bottom: 0;
            height: 3px;
            width: 100%;
            background: linear-gradient(90deg, #60a5fa, #2563eb);
            transform-origin: left;
            animation-name: app-update-banner-shrink;
            animation-timing-function: linear;
            animation-fill-mode: forwards;
          }
          @keyframes app-update-banner-shrink {
            from {
              transform: scaleX(1);
            }
            to {
              transform: scaleX(0);
            }
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <div className="page-wrapper dashboard-home p-0 Custom_home">
        <div className="custom_header">
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', width: '100%' }}>
            <div className="leftside_header">
              <FaBars
                size={26}
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(true)}
              />

              <img src={ProfilePhoto} className="profile" alt="Profile" />
            </div>
            <div className="rightside_header">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-1">
                <div className="d-flex align-items-center gap-1">
                  <h3 className="mb-0">{displayName}</h3>
                  <Link to="/AapproveStudentInfo" className="text-primary ms-1"><FaEdit size={13} /></Link>
                  <Link to="/studentprofileview" className="text-primary ms-1"><FaEye size={13} /></Link>
                </div>
                <button className="btn btn-light switch-btn py-1 px-2" onClick={handleAccountSwitchClick}>
                  <FaSyncAlt className="me-1" size={10} /> Switch Account
                </button>
              </div>
              {GetstudentData?.cls_sec?.cls?.Classes && (
                <p className="mb-0">
                  Class {GetstudentData?.cls_sec?.cls?.Classes} - {GetstudentData?.cls_sec?.section?.section} • Adm No: {GetstudentData?.admission_num}
                </p>
              )}
              {GetstudentData?.contact_phone && (
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-1 mt-0">
                  <p className="mb-0">
                    +91-{GetstudentData?.contact_phone} • Session: {sessionName}
                  </p>
                  {selectedHouse?.name && (
                    <span className="d-inline-flex align-items-center ms-1">
                      <span className={houseBadgeProps.className} style={houseBadgeProps.style}>
                        {selectedHouse?.name}
                      </span>
                      <button
                        type="button"
                        className="btn btn-sm p-0 border-0 text-muted ms-1"
                        onClick={handleRefreshHouse}
                        title="Refresh House Data"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          background: "transparent",
                          outline: "none",
                          lineHeight: 1
                        }}
                      >
                        <FaSyncAlt
                          size={11}
                          className={isRefreshingHouse ? "fa-spin" : ""}
                          style={{
                            animation: isRefreshingHouse ? "spin 0.8s linear infinite" : "none"
                          }}
                        />
                      </button>
                    </span>
                  )}
                </div>
              )}
            </div>

          </div>
          {isAccountDropdownOpen && (
            <div className="account-switch-dropdown shadow border bg-white rounded-3">
              <div className="account-switch-header d-flex align-items-center justify-content-between mb-2">
                <span className="fw-semibold text-dark">Choose Account</span>
              </div>
              {siblingAccounts && siblingAccounts.length > 0 ? (
                <div className="account-switch-list">
                  {siblingAccounts.map((sibling) => {
                    const isActive = sibling.username === activeSiblingUser;
                    return (
                      <button
                        type="button"
                        key={`${sibling.username}-${sibling.full_name}`}
                        className={`account-switch-option w-100 text-start ${isActive ? "active" : ""
                          }`}
                        onClick={() => handleAccountSelection(sibling)}
                      >
                        <span className="d-block fw-semibold text-dark">
                          {sibling.full_name || "Unnamed"}
                        </span>
                        <small className="text-muted d-block">
                          {sibling.username}
                          {isActive ? " · Current" : ""}
                        </small>
                      </button>
                    );
                  })}
                </div>
              ) : (
                <div className="text-muted small">
                  No other accounts available. Tap Manage to add/switch.
                </div>
              )}
            </div>
          )}
        </div>

        {anyUpdateAlerts.length > 0 && (
          <div className="app-update-banner-wrap">
            {anyUpdateAlerts.map((update) => (
              <div className="app-update-banner" key={update.id}>
                <span className="app-update-banner-icon-badge">
                  <FaInfoCircle className="app-update-banner-icon" />
                </span>
                <div className="app-update-banner-body">
                  <div className="app-update-banner-title">Update</div>
                  <div className="app-update-banner-text">{update.message}</div>
                </div>
                <button
                  type="button"
                  className="app-update-banner-ok"
                  onClick={() => dismissAnyUpdateAlert(update)}
                >
                  OK
                </button>
                <div
                  className="app-update-banner-timer"
                  style={{ animationDuration: `${ANY_UPDATE_ALERT_DURATION_MS}ms` }}
                />
              </div>
            ))}
          </div>
        )}

        <div className="Custon_inner_body">
          <div className="top-cards">
            {/* Transport Card */}
            <div className="card_main">
              <div className="card_2">
                <div className="card_icon">
                  <FaBus />
                </div>
                <div className="card_content">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="title" style={{ fontSize: "11px", fontWeight: "600" }}>Transport</span>
                    {hasTransport && (
                      <button
                        type="button"
                        className="collapse-btn text-muted p-0 border-0 bg-transparent ms-1"
                        onClick={() => setShowTransportDetails(!showTransportDetails)}
                        title={showTransportDetails ? "Collapse Details" : "Expand Details"}
                      >
                        {showTransportDetails ? <FaChevronUp /> : <FaChevronDown />}
                      </button>
                    )}
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-1 mt-1 flex-wrap">
                    {loadingTransport ? (
                      <span className="badge text-secondary bg-light border" style={{ fontSize: '9px', fontWeight: '600', padding: '2px 5px', borderRadius: '4px' }}>
                        Loading...
                      </span>
                    ) : TransportData.data?.length > 0 ? (
                      <span className="badge" style={{ backgroundColor: '#dcfce7', color: '#15803d', border: '1px solid #bbf7d0', fontSize: '9px', fontWeight: '700', padding: '2px 5px', borderRadius: '4px' }}>
                        YES
                      </span>
                    ) : TransportData.data?.length === 0 ? (
                      <span className="badge" style={{ backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1', fontSize: '9px', fontWeight: '700', padding: '2px 5px', borderRadius: '4px' }}>
                        Self
                      </span>
                    ) : (
                      <span className="badge" style={{ backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1', fontSize: '9px', fontWeight: '700', padding: '2px 5px', borderRadius: '4px' }}>
                        --
                      </span>
                    )}
                    {!loadingTransport && hasTransport && (
                      <button
                        type="button"
                        className="action-btn m-0"
                        onClick={handleOpenTrackModal}
                      >
                        Track
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Fees Card */}
            <div className="card_main">
              <div className={`card_2 ${isDueFee ? "fee-pending-tile-blink" : ""}`}>
                <div className={`card_icon ${isDueFee ? "red-bg-blink" : "green-bg"}`}>
                  <FaMoneyBillWave />
                </div>
                <div className="card_content">
                  <p className={`title ${isDueFee ? "text-danger fw-bold" : ""}`}>
                    {isDueFee ? "Fees Pending" : "Fees"}
                  </p>
                  <div className="card_actions">
                    <Link to="/FeeCollection">
                      <button className={`action-btn ${isDueFee ? "btn-danger-action btn-pulse" : ""}`}>
                        Pay
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Canteen Order Card */}
            <div className="card_main">
              <div className="card_2">
                <div className="card_icon orange-bg">
                  <FaShoppingCart />
                </div>
                <div className="card_content">
                  <p className="title">Canteen</p>
                  <div className="card_actions">
                    <Link to="/Canteen">
                      <button className="action-btn">
                        View
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showTransportDetails && (
            <div className="transport-expanded-container">
              {/* PART 1: Transport Attendance Summary */}
              <div className="attendance-card mb-2">
                <div className="left-border"></div>
                <div className="attendance-content">
                  {/* TOP */}
                  <div className="attendance-header">
                    <div className="icon-box blue-icon-box">
                      <FaBus />
                    </div>

                    <div>
                      <h5 className="title">Transport Attendance</h5>
                      <span className="month">
                        Today:{" "}
                        {todayHoliday ? (
                          <span className="today-attendance-badge leave ms-1">
                            Holiday: {todayHoliday.title}
                          </span>
                        ) : todayPickupAttendance ? (
                          <>
                            <span className="fw-semibold ms-1" style={{ fontSize: '10px' }}>Pick:</span>
                            <span
                              className={`today-attendance-badge ms-1 ${(todayPickupAttendance?.status || "").toLowerCase() === "present"
                                ? "present"
                                : (todayPickupAttendance?.status || "").toLowerCase() === "absent"
                                  ? "absent"
                                  : (todayPickupAttendance?.status || "").toLowerCase() === "leave"
                                    ? "leave"
                                    : "not-marked"
                                }`}
                            >
                              {formatStatusText(todayPickupAttendance?.status)}
                            </span>
                            <span className="fw-semibold ms-2" style={{ fontSize: '10px' }}>Drop:</span>
                            <span
                              className={`today-attendance-badge ms-1 ${(todayPickupAttendance?.out_status || "").toLowerCase() === "present"
                                ? "present"
                                : (todayPickupAttendance?.out_status || "").toLowerCase() === "absent"
                                  ? "absent"
                                  : (todayPickupAttendance?.out_status || "").toLowerCase() === "leave"
                                    ? "leave"
                                    : "not-marked"
                                }`}
                            >
                              {formatStatusText(todayPickupAttendance?.out_status || "not-marked")}
                            </span>
                          </>
                        ) : (
                          <span
                            className={`today-attendance-badge ${(todayTransportAttendanceStatus || "").toLowerCase() === "present"
                              ? "present"
                              : (todayTransportAttendanceStatus || "").toLowerCase() === "absent"
                                ? "absent"
                                : (todayTransportAttendanceStatus || "").toLowerCase() === "leave"
                                  ? "leave"
                                  : "not-marked"
                              }`}
                          >
                            {formatStatusText(todayTransportAttendanceStatus)}
                          </span>
                        )}
                      </span>
                    </div>
                  </div>

                  {/* BODY */}
                  <div className="attendance-body">
                    {/* LEFT PERCENT */}
                    <div className="percent">
                      <h1>{tAttendancePercentage}</h1>
                    </div>

                    {/* CENTER STATS */}
                    <div className="stats">
                      <div>
                        <p className="label_percent">Present</p>
                        <span className="value_percent text-success">{tPresentDays}</span>
                      </div>

                      <div className="divider_percent"></div>

                      <div>
                        <p className="label_percent">Absent</p>
                        <span className="value_percent red">{tAbsentDays}</span>
                      </div>
                      <div className="divider_percent"></div>

                      <div>
                        <p className="label_percent">Leave</p>
                        <span className="value_percent text-warning">{tLeaveDays}</span>
                      </div>
                    </div>

                    {/* BUTTON */}
                    <Link to="/attendance">
                      <button className="view-btn_percent">
                        View Details →
                      </button>
                    </Link>
                  </div>
                </div>
              </div>

              {/* PART 2: Transport Route & Driver Info */}
              <div className="attendance-card">
                <div className="left-border"></div>
                {TransportData?.data?.map((transportItem, index) => {
                  const latestExitDetail =
                    transportItem.vehicle_exit_details?.length > 0
                      ? [...transportItem.vehicle_exit_details].sort(
                        (a, b) => new Date(b.date) - new Date(a.date)
                      )[0]
                      : null;

                  const latestStoppageReachTime =
                    latestExitDetail?.stoppage_reach_time || "--";

                  const latestDropStoppageReachTime =
                    latestExitDetail?.drop_stoppage_reach_time || "--";

                  return (
                    <div className="attendance-content" key={index}>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h5 className="title mb-0">Bus & Driver Info</h5>
                        <button
                          type="button"
                          className="collapse-btn text-muted p-0 border-0 bg-transparent ms-1"
                          onClick={() => setShowBusDriverDetails(!showBusDriverDetails)}
                          title={showBusDriverDetails ? "Collapse Bus & Driver Info" : "Expand Bus & Driver Info"}
                        >
                          {showBusDriverDetails ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      </div>

                      {showBusDriverDetails && (
                        <div className="d-flex flex-column gap-2">
                          {/* Substitute Bus & Staff Block */}
                          {(() => {
                            const subList = getSubstituteList(transportItem);
                            if (subList.length === 0) return null;

                            return subList.map((subItem, subIdx) => {
                              const subDriverName = subItem?.substitute_driver_name ||
                                subItem?.driver_name ||
                                subItem?.morningShiftDriver?.staff_full_name ||
                                subItem?.eveningShiftDriver?.staff_full_name ||
                                subItem?.driver_details?.morningShiftDriver?.staff_full_name ||
                                subItem?.driver_details?.eveningShiftDriver?.staff_full_name;

                              const subDriverContact = subItem?.substitute_driver_contact_no ||
                                subItem?.substitute_driver_mobile_no ||
                                subItem?.substitute_vehicle_details?.driver_contact_no ||
                                subItem?.vehicle_details?.driver_contact_no ||
                                subItem?.driver_contact_no ||
                                subItem?.morningShiftDriver?.mobile_no ||
                                subItem?.eveningShiftDriver?.mobile_no ||
                                subItem?.driver_details?.morningShiftDriver?.mobile_no ||
                                subItem?.driver_details?.eveningShiftDriver?.mobile_no;

                              const subAttendeeName = subItem?.substitute_attendee_name ||
                                subItem?.attendee_name ||
                                subItem?.morningShiftAttendee?.staff_full_name ||
                                subItem?.eveningShiftAttendee?.staff_full_name ||
                                subItem?.driver_details?.morningShiftAttendee?.staff_full_name ||
                                subItem?.driver_details?.eveningShiftAttendee?.staff_full_name;

                              const subAttendeeContact = subItem?.substitute_attendee_contact_no ||
                                subItem?.substitute_attendee_mobile_no ||
                                subItem?.substitute_vehicle_details?.attendee_contact_no ||
                                subItem?.vehicle_details?.attendee_contact_no ||
                                subItem?.attendee_contact_no ||
                                subItem?.morningShiftAttendee?.mobile_no ||
                                subItem?.eveningShiftAttendee?.mobile_no ||
                                subItem?.driver_details?.morningShiftAttendee?.mobile_no ||
                                subItem?.driver_details?.eveningShiftAttendee?.mobile_no;

                              return (
                                <div key={subIdx} className="p-2.5 rounded-3 border border-warning" style={{ backgroundColor: "#fffbeb" }}>
                                  <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom border-warning border-opacity-25">
                                    <div className="d-flex align-items-center gap-1.5">
                                      <FaExclamationTriangle className="text-warning" size={14} />
                                      <strong className="text-dark" style={{ fontSize: "12px" }}>Substitute Bus Assigned</strong>
                                      {subItem?.substitute_date && (
                                        <span className="text-muted" style={{ fontSize: "11px" }}>({subItem.substitute_date})</span>
                                      )}
                                    </div>
                                    {subItem?.trip && (
                                      <span className="badge bg-warning text-dark font-weight-bold text-capitalize" style={{ fontSize: "9.5px" }}>
                                        {subItem.trip}
                                      </span>
                                    )}
                                  </div>

                                  <div className="route-grid">
                                    {(subDriverName || subDriverContact) && (
                                      <div className="route-item" style={{ backgroundColor: "#ffffff" }}>
                                        <FaUserTie className="route-icon text-warning" />
                                        <div>
                                          <small className="d-block text-warning font-weight-bold">
                                            Substitute Driver {subItem?.trip ? `(${subItem.trip})` : ''}
                                          </small>
                                          <h6 className="mb-0 text-dark font-weight-semibold">
                                            {subDriverName || '--'}
                                          </h6>
                                          {subDriverContact ? (
                                            <a href={`tel:${subDriverContact}`} className="text-primary small font-weight-bold">
                                              {subDriverContact}
                                            </a>
                                          ) : (
                                            <span className="text-muted small">--</span>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {(subAttendeeName || subAttendeeContact) && (
                                      <div className="route-item" style={{ backgroundColor: "#ffffff" }}>
                                        <FaUserTie className="route-icon text-warning" />
                                        <div>
                                          <small className="d-block text-warning font-weight-bold">
                                            Substitute Attendee {subItem?.trip ? `(${subItem.trip})` : ''}
                                          </small>
                                          <h6 className="mb-0 text-dark font-weight-semibold">
                                            {subAttendeeName || '--'}
                                          </h6>
                                          {subAttendeeContact ? (
                                            <a href={`tel:${subAttendeeContact}`} className="text-primary small font-weight-bold">
                                              {subAttendeeContact}
                                            </a>
                                          ) : (
                                            <span className="text-muted small">--</span>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    <div className="route-item" style={{ backgroundColor: "#ffffff" }}>
                                      <FaBus className="route-icon text-warning" />
                                      <div>
                                        <small className="d-block text-muted">Substitute Vehicle</small>
                                        <h6 className="mb-0 text-dark font-weight-semibold">
                                          {subItem?.substitute_vehicle_number || subItem?.vehicle_number || '--'}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            });
                          })()}

                          {/* Regular Bus & Driver Block */}
                          <div className="transport-modern-card">
                            {getSubstituteList(transportItem).length > 0 && (
                              <div className="d-flex align-items-center gap-1.5 mb-2 pb-1 border-bottom">
                                <FaBus className="text-primary me-2" size={14} />
                                <strong className="text-dark me-2" style={{ fontSize: "12px" }}>Original Bus Info</strong>
                              </div>
                            )}
                            <div className="route-grid">
                              {transportItem?.driver_details?.morningShiftDriver && (
                                <div className="route-item">
                                  <FaUserTie className="route-icon" />
                                  <div>
                                    <small className="d-block text-muted">Pick Driver</small>
                                    <h6 className="mb-0 text-dark font-weight-semibold">{transportItem?.driver_details?.morningShiftDriver?.staff_full_name || '--'}</h6>
                                    <a href={`tel:${transportItem?.vehicle_details?.driver_contact_no || transportItem?.driver_details?.morningShiftDriver?.mobile_no}`} className="text-primary small font-weight-bold">
                                      {transportItem?.vehicle_details?.driver_contact_no || transportItem?.driver_details?.morningShiftDriver?.mobile_no || '--'}
                                    </a>
                                  </div>
                                </div>
                              )}

                              {transportItem?.driver_details?.eveningShiftDriver && (
                                <div className="route-item">
                                  <FaUserTie className="route-icon" />
                                  <div>
                                    <small className="d-block text-muted">Drop Driver</small>
                                    <h6 className="mb-0 text-dark font-weight-semibold">{transportItem?.driver_details?.eveningShiftDriver?.staff_full_name || '--'}</h6>
                                    <a href={`tel:${transportItem?.vehicle_details?.driver_contact_no || transportItem?.driver_details?.eveningShiftDriver?.mobile_no}`} className="text-primary small font-weight-bold">
                                      {transportItem?.vehicle_details?.driver_contact_no || transportItem?.driver_details?.eveningShiftDriver?.mobile_no || '--'}
                                    </a>
                                  </div>
                                </div>
                              )}

                              {transportItem?.driver_details?.morningShiftAttendee && (
                                <div className="route-item">
                                  <FaUserTie className="route-icon" />
                                  <div>
                                    <small className="d-block text-muted">Pick Attendee</small>
                                    <h6 className="mb-0 text-dark font-weight-semibold">{transportItem?.driver_details?.morningShiftAttendee?.staff_full_name || '--'}</h6>
                                    <a href={`tel:${transportItem?.vehicle_details?.attendee_contact_no || transportItem?.driver_details?.morningShiftAttendee?.mobile_no}`} className="text-primary small font-weight-bold">
                                      {transportItem?.vehicle_details?.attendee_contact_no || transportItem?.driver_details?.morningShiftAttendee?.mobile_no || '--'}
                                    </a>
                                  </div>
                                </div>
                              )}

                              {transportItem?.driver_details?.eveningShiftAttendee && (
                                <div className="route-item">
                                  <FaUserTie className="route-icon" />
                                  <div>
                                    <small className="d-block text-muted">Drop Attendee</small>
                                    <h6 className="mb-0 text-dark font-weight-semibold">{transportItem?.driver_details?.eveningShiftAttendee?.staff_full_name || '--'}</h6>
                                    <a href={`tel:${transportItem?.vehicle_details?.attendee_contact_no || transportItem?.driver_details?.eveningShiftAttendee?.mobile_no}`} className="text-primary small font-weight-bold">
                                      {transportItem?.vehicle_details?.attendee_contact_no || transportItem?.driver_details?.eveningShiftAttendee?.mobile_no || '--'}
                                    </a>
                                  </div>
                                </div>
                              )}

                              <div className="route-item">
                                <FaBus className="route-icon" />
                                <div>
                                  <small className="d-block text-muted">Bus Route</small>
                                  <h6 className="mb-1 text-dark font-weight-semibold" style={{ fontSize: "11px", lineHeight: "1.2" }}>
                                    {transportItem?.route_details?.startplace?.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())} {transportItem?.route_details?.endplace?.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())} ({transportItem?.route_details?.code})
                                  </h6>
                                  <div className="text-muted" style={{ fontSize: "10px" }}>
                                    <div>Vehicle: <strong>{transportItem?.vehicle_details?.vehicle_number || '--'}</strong></div>
                                    <div>Service: <strong className="text-capitalize">{formatServiceType(transportItem?.service_type)}</strong></div>
                                  </div>
                                </div>
                              </div>

                              <div className="route-item">
                                <FaMapMarkerAlt className="route-icon" />
                                <div>
                                  <small className="d-block text-muted">Pickup Stop & Time</small>
                                  <h6 className="mb-0 text-dark font-weight-semibold" style={{ fontSize: "11px", lineHeight: "1.2" }}>
                                    {transportItem?.stoppage_details?.stop_name?.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}
                                  </h6>
                                  <small className="d-block text-muted">Expected Reach Time</small>
                                  <h6 className="mb-0 text-dark font-weight-semibold" style={{ fontSize: "11px", lineHeight: "1.2" }}>
                                    {latestStoppageReachTime}
                                  </h6>
                                  <small className="d-block text-muted">Stoppage Reach Time</small>
                                  <h6 className="mb-0 text-dark font-weight-semibold" style={{ fontSize: "11px", lineHeight: "1.2" }}>
                                    {latestDropStoppageReachTime}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}

              </div>

            </div>
          )}



          <div className="attendance-card">

            {/* LEFT BORDER LINE */}
            <div className="left-border"></div>

            {/* MAIN CONTENT */}
            <div className="attendance-content">

              {/* TOP */}
              <div className="attendance-header">
                <div className="d-flex align-items-center gap-2">
                  <div className="icon-box">
                    <FaCalendarCheck />
                  </div>

                  <div>
                    <h5 className="title">Attendance</h5>
                    <span className="month">
                      Today:{" "}
                      {todayHoliday ? (
                        <span className="today-attendance-badge leave ms-1">
                          Holiday: {todayHoliday.title}
                        </span>
                      ) : (
                        <span
                          className={`today-attendance-badge ${(todayAttendanceStatus || "").toLowerCase() === "present"
                            ? "present"
                            : (todayAttendanceStatus || "").toLowerCase() === "absent"
                              ? "absent"
                              : (todayAttendanceStatus || "").toLowerCase() === "leave"
                                ? "leave"
                                : "not-marked"
                            }`}
                        >
                          {formatStatusText(todayAttendanceStatus)}
                        </span>
                      )}
                      {!todayHoliday && todayLateInTime && (
                        <span className="today-attendance-badge late late-blink ms-1">
                          Late {todayLateInTime}
                        </span>
                      )}
                    </span>
                  </div>
                </div>

                {isStudentSuspendedToday && (
                  <div
                    className="d-flex align-items-center gap-2 mt-2 px-2 py-1 rounded"
                    style={{
                      backgroundColor: "#fff5f5",
                      border: "1px solid #fecaca",
                      color: "#dc2626",
                      fontSize: "12px",
                      fontWeight: "600",
                      animation: "blinkSuspendedBanner 1.5s infinite ease-in-out",
                    }}
                  >
                    <FaExclamationTriangle style={{ fontSize: "13px", flexShrink: 0, animation: "blinkSuspendedIcon 1s infinite" }} />
                    <span>Warning: Student is Currently Suspended Today</span>
                  </div>
                )}
              </div>


              {/* BODY */}
              <div className="attendance-body">

                {/* LEFT PERCENT */}
                <div className="percent">
                  <h1 style={isBelowMinAttendance ? { color: "#dc2626" } : undefined}>
                    {String(attendancePercentage).endsWith("%") ? attendancePercentage : `${attendancePercentage}%`}
                  </h1>
                </div>

                {/* CENTER STATS */}
                <div className="stats">
                  <div>
                    <p className="label_percent">Present</p>
                    <span className="value_percent text-success">{presentDays}</span>
                  </div>

                  <div className="divider_percent"></div>

                  <div>
                    <p className="label_percent">Absent</p>
                    <span className="value_percent red">{absentDays}</span>
                  </div>
                  <div className="divider_percent"></div>

                  <div>
                    <p className="label_percent">Leave</p>
                    <span className="value_percent text-warning">{leaveDays}</span>
                  </div>
                </div>

                {/* BUTTON */}
                <Link to="/attendance">
                  <button className="view-btn_percent">
                    View Details →
                  </button>
                </Link>
              </div>

            </div>

          </div>

          {/* STANDALONE EVENT ATTENDANCE CARD */}
          {eventTrackCards.length > 0 && (
            <div className="card p-3 mt-2 shadow-sm border-0" style={{ borderRadius: '16px', backgroundColor: '#ffffff' }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{ width: '38px', height: '38px', backgroundColor: '#eef2ff', color: '#4f46e5' }}
                  >
                    <FaCalendarAlt className="fs-16" />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-0 text-dark fs-15">Event Attendance</h5>
                    <small className="text-muted fs-12">
                      Today: <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-2 py-0.5 rounded-pill fs-11">{eventTrackCards.length} Event(s)</span>
                    </small>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <Link to="/events" className="btn btn-sm btn-outline-primary rounded-pill px-3 py-1 fs-12 d-flex align-items-center gap-1">
                    <span>View Events</span>
                    <FaArrowRight className="fs-10" />
                  </Link>
                  <button
                    type="button"
                    className="btn btn-sm btn-light rounded-circle p-0 d-flex align-items-center justify-content-center"
                    style={{ width: '32px', height: '32px', border: '1px solid #e2e8f0' }}
                    onClick={() => setIsEventAttendanceCollapsed(!isEventAttendanceCollapsed)}
                    title={isEventAttendanceCollapsed ? "Expand" : "Collapse"}
                  >
                    {isEventAttendanceCollapsed ? <FaChevronDown className="text-secondary fs-12" /> : <FaChevronUp className="text-secondary fs-12" />}
                  </button>
                </div>
              </div>

              {!isEventAttendanceCollapsed && (
                <div className="mt-3 pt-3 border-top" style={{ borderColor: '#f1f5f9' }}>
                  <div className="d-flex flex-column gap-3">
                    {eventTrackCards.map((group, idx) => {
                      const groupBusInfo = group.booking ? getEventBusTrackingInfo(group.booking, group) : null;
                      // Events picked up from a booking carry no attendance date,
                      // so the event's own schedule is shown instead.
                      const startLabel = group.start_date ? formatDateDisplay(group.start_date) : null;
                      const endLabel = group.end_date ? formatDateDisplay(group.end_date) : null;
                      const eventDateLabel =
                        group.date ||
                        (startLabel && endLabel && startLabel !== endLabel
                          ? `${startLabel} - ${endLabel}`
                          : startLabel || endLabel || (group.due_date ? formatDateDisplay(group.due_date) : null));
                      const bookingStatus = group.booking?.status;
                      const paidStatus = group.booking?.paid_status;
                      const hasBusMapped = Boolean(
                        groupBusInfo?.activeTrackUrl || groupBusInfo?.activeVehicleNumber || group.vehicle_route_url
                      );
                      // Attendance rows without booking data keep the button:
                      // the modal loads the booking and explains what is missing.
                      const canTrack = hasBusMapped || !group.booking;
                      // Without a marked attendance there is still one row per
                      // event, so the bus stays trackable.
                      const rows = group.attendances.length > 0
                        ? group.attendances
                        : [{ synthetic: true, attendance_type: 'Event', status: 'not-marked' }];
                      const trackItem = {
                        event_id: group.event_id,
                        event_name: group.event_name,
                        start_date: group.start_date,
                        end_date: group.end_date,
                        due_date: group.due_date,
                        vehicle_route_url: group.vehicle_route_url,
                      };

                      return (
                        <div
                          key={group.event_id || group.event_name || idx}
                          className="p-3 rounded-3 border"
                          style={{ backgroundColor: '#f8fafc', borderColor: '#e2e8f0' }}
                        >
                          <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                            <h6 className="fw-bold text-dark fs-14 mb-0">{group.event_name?.trim() || 'Event'}</h6>
                            {eventDateLabel && (
                              <small className="text-muted fs-12 flex-shrink-0">Date: {eventDateLabel}</small>
                            )}
                          </div>



                          {groupBusInfo?.hasSubstitute && (
                            <div className="d-flex align-items-center flex-wrap gap-1 mb-2 fs-11 text-muted">
                              <FaBus className="text-warning fs-10" />
                              <span>
                                Substitute bus{' '}
                                <strong className="text-dark">{groupBusInfo.substitute?.vehicleNumber || '--'}</strong>
                              </span>
                              {groupBusInfo.substitute?.hasTrip && (
                                <span className="badge bg-light text-dark border fs-10">
                                  {groupBusInfo.substitute.tripLabel}
                                </span>
                              )}
                            </div>
                          )}

                          <div className="d-flex flex-column gap-2 mt-2">
                            {rows.map((att, attIdx) => (
                              <div
                                key={attIdx}
                                className="d-flex flex-wrap align-items-center justify-content-between p-2 rounded-2 bg-white border"
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <span className="badge bg-light text-dark border text-capitalize px-2.5 py-1 fs-11 fw-semibold">
                                    Type: {att.attendance_type || 'N/A'}
                                  </span>
                                </div>

                                <div className="d-flex align-items-center gap-2 flex-wrap ms-auto">
                                  <span
                                    className={`today-attendance-badge ${(att.status || "").toLowerCase() === "present"
                                      ? "present"
                                      : (att.status || "").toLowerCase() === "absent"
                                        ? "absent"
                                        : (att.status || "").toLowerCase() === "leave"
                                          ? "leave"
                                          : "not-marked"
                                      }`}
                                    style={{ textTransform: 'capitalize', fontSize: '11px', padding: '4px 10px' }}
                                  >
                                    {formatStatusText(att.status || 'not-marked')}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* One bus per event, so a single track button covers
                              every attendance row (pickup and dropoff). */}
                          <div className="d-flex justify-content-end mt-2">
                            {canTrack ? (
                              <button
                                type="button"
                                className={`btn btn-sm rounded-pill px-2.5 py-0.5 fs-11 d-flex align-items-center gap-1 ${groupBusInfo?.hasSubstitute ? 'btn-outline-warning' : 'btn-outline-primary'}`}
                                onClick={() => handleTrackEventVehicle(rows[0]?.synthetic ? trackItem : rows[0], group.booking)}
                              >
                                <FaBus className="fs-10" />
                                <span>Track Vehicle</span>
                              </button>
                            ) : (
                              <span className="text-muted fs-11 d-flex align-items-center gap-1">
                                <FaBus className="fs-10" />
                                Bus not assigned yet
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="card notif-panel mt-2">

            {/* Header */}
            <div className="notif-panel__head">
              <span className="notif-panel__bell">
                <FaBell />
              </span>
              <h5 className="notif-panel__title">Weekly Notifications</h5>

              <button
                type="button"
                className="notif-panel__refresh"
                title="Refresh"
                disabled={loadingNotifications}
                onClick={() => fetchNotifications(selectedModule)}
              >
                <FaSyncAlt className={loadingNotifications ? "notif-spin" : ""} />
              </button>
            </div>

            {/* Filters */}
            <div className="notif-panel__filters">
              <div className="notif-panel__search">
                <FaSearch className="notif-panel__search-icon" />
                <input
                  type="text"
                  placeholder="Search notifications..."
                  value={searchNotification}
                  onChange={(e) => setSearchNotification(e.target.value)}
                />
              </div>

              <div className="notif-panel__select">
                <Select
                  options={notificationSelectOptions}
                  value={
                    notificationSelectOptions.find(
                      (opt) => String(opt.value) === String(selectedModule)
                    ) || notificationSelectOptions[0]
                  }
                  onChange={(selectedOption) => {
                    const val = selectedOption ? selectedOption.value : "All";
                    setSelectedModule(val);
                    fetchNotifications(val);
                  }}
                  classNamePrefix="react-select"
                  isSearchable={false}
                  placeholder="All Modules"
                />
              </div>
            </div>

            {/* List */}
            {loadingNotifications ? (
              <div className="notif-panel__state">
                <Spinner animation="border" variant="primary" size="sm" />
                <p>Loading notifications...</p>
              </div>
            ) : displayedNotifications?.length > 0 ? (
              <div className="notif-panel__list">
                {displayedNotifications.map((notificationdat, index) => {
                  const moduleId =
                    notificationdat.module ??
                    notificationdat.module_id ??
                    notificationdat.moduleId;
                  const moduleLabel = getModuleLabel(moduleId);
                  const createdAt =
                    notificationdat.created_at ||
                    notificationdat.date ||
                    notificationdat.createdDate;
                  const isFresh = isFreshNotification(createdAt);
                  const notifKey = notificationdat.id || index;
                  const bodyText = String(notificationdat.body || "");
                  // Mirrors the 2-line clamp on .notif-item__text
                  const isLongBody = bodyText.length > 100 || bodyText.split("\n").length > 2;
                  const isExpanded = Boolean(expandedNotifications[notifKey]);

                  return (
                    <div
                      key={notifKey}
                      className="notif-item"
                      role="button"
                      tabIndex={0}
                      onClick={() => handleNotificationClick(notificationdat)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleNotificationClick(notificationdat);
                        }
                      }}
                    >
                      <div className="notif-item__rail">
                        <span
                          className="notif-item__node"
                          data-module={moduleLabel.toLowerCase()}
                        >
                          {getModuleIcon(moduleLabel)}
                        </span>
                      </div>

                      <div className="notif-item__body">
                        <div className="notif-item__top">
                          <h6 className="notif-item__title">
                            {notificationdat?.notification ||
                              notificationdat?.title ||
                              "Notification"}
                          </h6>
                          {isFresh && <span className="notif-item__new">New</span>}
                        </div>

                        {notificationdat.body && (
                          <>
                            <p className={`notif-item__text${isExpanded ? " is-expanded" : ""}`}>
                              {notificationdat.body}
                            </p>
                            {isLongBody && (
                              <button
                                type="button"
                                className="notif-item__toggle"
                                onClick={(e) => {
                                  // Only expand the text - don't open the notification
                                  e.stopPropagation();
                                  setExpandedNotifications((prev) => ({
                                    ...prev,
                                    [notifKey]: !prev[notifKey],
                                  }));
                                }}
                                onKeyDown={(e) => e.stopPropagation()}
                              >
                                {isExpanded ? "Read less" : "Read more"}
                              </button>
                            )}
                          </>
                        )}

                        <div className="notif-item__foot">
                          <span className="notif-item__meta">
                            {moduleLabel}
                            {createdAt ? ` · ${formatRelativeTime(createdAt)}` : ""}
                          </span>
                          <span className="notif-item__go">
                            View details
                            <FaChevronRight />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* Sits at the end of the scrolled list, not pinned below it */}
                {visibleNotificationCount < filteredNotifications.length && (
                  <button
                    type="button"
                    className="notif-panel__more"
                    onClick={() => setVisibleNotificationCount((prev) => prev + 10)}
                  >
                    Load More
                  </button>
                )}
              </div>
            ) : (
              <div className="notif-panel__state">
                <FaBell className="notif-panel__state-icon" />
                <p>No notifications found</p>
              </div>
            )}
          </div>

          <h5 className="quick-actions-heading">Quick Actions</h5>
          <div className="quick-actions-grid mb-3">
            <Link to={routes.FeeCollection} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <FaMoneyBillWave />
                </div>
                <p>School Fees</p>
              </div>
            </Link>

            <Link to={routes.SchoolNotice} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbBell />
                </div>
                <p>Notice</p>
              </div>
            </Link>

            <Link to={routes.HomeWork} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbFileText />
                </div>
                <p>Home/Class work</p>
              </div>
            </Link>

            <Link to={routes.timetable} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbClock />
                </div>
                <p>Time Table</p>
              </div>
            </Link>

            <Link to={routes.Canteen} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <FaUtensils />
                </div>
                <p>Canteen</p>
              </div>
            </Link>

            <Link to={routes.userObservation} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbEye />
                </div>
                <p>User Observation</p>
              </div>
            </Link>

            <Link to={routes.StudentGatePass} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbIdBadge2 />
                </div>
                <p>Student Gate Pass</p>
              </div>
            </Link>

            <Link to={routes.studentLeaves} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbCalendarCheck />
                </div>
                <p>Apply Leave</p>
              </div>
            </Link>

            <Link to={routes.syllabus} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbBook />
                </div>
                <p>Syllabus</p>
              </div>
            </Link>

            <Link to={routes.events} className="text-decoration-none">
              <div className={`quick-card ${hasNewEvents ? "new-event-tile-blink" : ""}`}>
                {hasNewEvents && <span className="new-event-star">*</span>}
                <div className="icon">
                  <TbBooks />
                </div>
                <p>Event Participation</p>
              </div>
            </Link>

            <Link to={routes.chaptertest} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbFileCheck />
                </div>
                <p>Chapter Test</p>
              </div>
            </Link>

            <Link to={routes.Exam} className="text-decoration-none">
              <div className="quick-card">
                <div className="icon">
                  <TbTrophy />
                </div>
                <p>Exam</p>
              </div>
            </Link>
          </div>


          {filteredMenuData?.map((menu, index) => (
            <div key={index} className="mb-2">


              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="section-title">
                  {menu.label}
                </h5>
              </div>

              <div className="row g-2">
                {(expandedMenus[menu.id]
                  ? menu.submenuItems
                  : menu.submenuItems?.slice(0, 4)
                )?.map((item, i) => (
                  <div className="col-6 mb-1" key={i}>

                    <Link
                      to={
                        (resolveRoute(item.link) === "/transportinfo" || item.link === "/transportinfo" || item.link === "routes.transportinfo")
                          ? "#"
                          : item.submenuItems?.length > 0
                            ? routes.submenu
                            : resolveRoute(item.link)
                      }
                      onClick={(e) => {
                        if (resolveRoute(item.link) === "/transportinfo" || item.link === "/transportinfo" || item.link === "routes.transportinfo") {
                          e.preventDefault();
                          handleOpenTrackModal();
                        }
                      }}
                      state={{
                        id: item.id,
                        label: item.label,
                        submenuItems: item.submenuItems
                      }}
                      className="text-decoration-none"
                    >
                      <div className={`menu-card ${hasNewEvents && resolveRoute(item.link) === routes.events ? "new-event-tile-blink" : ""}`}>
                        {hasNewEvents && resolveRoute(item.link) === routes.events && (
                          <span className="new-event-star">*</span>
                        )}

                        <div className="left">
                          <div className={`menu-icon ${item.label?.toLowerCase() === 'syllabus' ? 'purple-icon' : 'blue-icon'}`}>
                            {getMenuIcon(item.label)}
                          </div>

                          <span>{item.label}</span>
                        </div>

                        <FaChevronRight className="arrow" />
                      </div>
                    </Link>

                  </div>
                ))}
              </div>

              {menu.submenuItems?.length > 4 && (
                <div className="text-center mt-1 mb-1">
                  <button
                    className="view-all-pill-btn"
                    onClick={() => toggleMenu(menu.id)}
                  >
                    {expandedMenus[menu.id] ? "Show Less" : "+ View All"}
                  </button>
                </div>
              )}
            </div>
          ))}

          {/* Transport Live Tracking Modal */}
          <Modal show={showTrackModal} onHide={() => setShowTrackModal(false)} size="lg" centered className="transport-modal">
            <Modal.Header closeButton className="border-0 pb-0 bg-light">
              <div className="d-flex align-items-center gap-2">
                <Modal.Title className="fw-bold text-dark d-flex align-items-center gap-2 mb-0">
                  <FaBus className="text-primary" />
                  Live Transport Tracking
                </Modal.Title>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                  onClick={handleRefreshTrackMap}
                  disabled={trackLoading}
                  title="Refresh map"
                >
                  <FaSyncAlt size={12} className={trackLoading ? "fa-spin" : ""} />
                  Refresh
                </button>
              </div>
            </Modal.Header>
            <Modal.Body className="p-3 bg-light">
              {(() => {
                const transportRecord = TransportData?.data?.[0] || {};
                const subList = getActiveSubstituteList(transportRecord);
                const hasSubstitute = subList.length > 0;

                // No manual choice: a substitute active for the current leg is the
                // bus that will arrive, otherwise it is the original bus.
                const selectedSub = subList[0] || {};
                const substituteDate = selectedSub?.substitute_date;
                const substituteTrip = selectedSub?.trip;
                const substituteVehicleNo = selectedSub?.substitute_vehicle_number || selectedSub?.vehicle_number;
                const originalVehicleNo = transportRecord?.vehicle_details?.vehicle_number;

                const subDriverName = selectedSub?.substitute_driver_name ||
                  selectedSub?.driver_name ||
                  selectedSub?.morningShiftDriver?.staff_full_name ||
                  selectedSub?.eveningShiftDriver?.staff_full_name ||
                  selectedSub?.driver_details?.morningShiftDriver?.staff_full_name ||
                  selectedSub?.driver_details?.eveningShiftDriver?.staff_full_name;

                const subDriverContact = selectedSub?.substitute_driver_contact_no ||
                  selectedSub?.substitute_driver_mobile_no ||
                  selectedSub?.substitute_vehicle_details?.driver_contact_no ||
                  selectedSub?.vehicle_details?.driver_contact_no ||
                  selectedSub?.driver_contact_no ||
                  selectedSub?.morningShiftDriver?.mobile_no ||
                  selectedSub?.eveningShiftDriver?.mobile_no ||
                  selectedSub?.driver_details?.morningShiftDriver?.mobile_no ||
                  selectedSub?.driver_details?.eveningShiftDriver?.mobile_no;

                const subAttendeeName = selectedSub?.substitute_attendee_name ||
                  selectedSub?.attendee_name ||
                  selectedSub?.morningShiftAttendee?.staff_full_name ||
                  selectedSub?.eveningShiftAttendee?.staff_full_name ||
                  selectedSub?.driver_details?.morningShiftAttendee?.staff_full_name ||
                  selectedSub?.driver_details?.eveningShiftAttendee?.staff_full_name;

                const subAttendeeContact = selectedSub?.substitute_attendee_contact_no ||
                  selectedSub?.substitute_attendee_mobile_no ||
                  selectedSub?.substitute_vehicle_details?.attendee_contact_no ||
                  selectedSub?.vehicle_details?.attendee_contact_no ||
                  selectedSub?.attendee_contact_no ||
                  selectedSub?.morningShiftAttendee?.mobile_no ||
                  selectedSub?.eveningShiftAttendee?.mobile_no ||
                  selectedSub?.driver_details?.morningShiftAttendee?.mobile_no ||
                  selectedSub?.driver_details?.eveningShiftAttendee?.mobile_no;

                const subTrackUrl = (typeof selectedSub?.substitute_vehicle_route_url === 'object'
                  ? selectedSub?.substitute_vehicle_route_url?.vehicle_route_url
                  : selectedSub?.substitute_vehicle_route_url) ||
                  selectedSub?.vehicle_route_url;

                const origTrackUrl = transportRecord?.vehicle_details?.vehicle_route_url;

                const isSubstituteSelected = hasSubstitute;
                const activeTrackUrl = isSubstituteSelected
                  ? (subTrackUrl || origTrackUrl)
                  : (origTrackUrl || subTrackUrl);

                const pickStartTime = transportRecord?.pick_start_time || selectedSub?.pick_start_time;
                const pickEndTime = transportRecord?.pick_end_time || selectedSub?.pick_end_time;
                const dropStartTime = transportRecord?.drop_start_time || selectedSub?.drop_start_time;
                const dropEndTime = transportRecord?.drop_end_time || selectedSub?.drop_end_time;

                const hasPickWindow = Boolean(pickStartTime && pickEndTime);
                const hasDropWindow = Boolean(dropStartTime && dropEndTime);

                const inPickRange = hasPickWindow ? isCurrentTimeInRange(pickStartTime, pickEndTime) : true;
                const inDropRange = hasDropWindow ? isCurrentTimeInRange(dropStartTime, dropEndTime) : true;

                let isTrackingTimeValid = true;
                let activeWindowType = "both";

                const subTrip = isSubstituteSelected ? normalizeSubstituteTrip(substituteTrip) : null;

                if (subTrip === "pick") {
                  activeWindowType = "pick";
                  isTrackingTimeValid = hasPickWindow ? inPickRange : true;
                } else if (subTrip === "drop") {
                  activeWindowType = "drop";
                  isTrackingTimeValid = hasDropWindow ? inDropRange : true;
                } else {
                  activeWindowType = "both";
                  if (hasPickWindow || hasDropWindow) {
                    const validPick = hasPickWindow ? inPickRange : false;
                    const validDrop = hasDropWindow ? inDropRange : false;
                    isTrackingTimeValid = validPick || validDrop;
                  }
                }

                return (
                  <div>
                    <div
                      className="bg-white rounded-4 border shadow-sm mb-3 overflow-hidden"
                      style={{ borderLeft: `4px solid ${isSubstituteSelected ? '#f7a600' : '#3d5ee1'}` }}
                    >
                      <div className="d-flex align-items-center gap-3 p-3">
                        <div
                          className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                          style={{ width: '44px', height: '44px', backgroundColor: isSubstituteSelected ? '#fff5e0' : '#eceffd' }}
                        >
                          <FaBus size={20} className={isSubstituteSelected ? 'text-warning' : 'text-primary'} />
                        </div>

                        <div className="flex-grow-1" style={{ minWidth: 0 }}>
                          <span className="text-muted text-uppercase d-block" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
                            Bus Arriving Now
                          </span>
                          <div className="d-flex align-items-center flex-wrap gap-2 mt-1">
                            <strong className="text-dark" style={{ fontSize: '17px', letterSpacing: '0.5px' }}>
                              {(isSubstituteSelected ? substituteVehicleNo : originalVehicleNo) || 'N/A'}
                            </strong>
                            {isSubstituteSelected ? (
                              <span className="badge bg-warning text-dark" style={{ fontSize: '9px' }}>Substitute Bus</span>
                            ) : (
                              <span className="badge bg-secondary" style={{ fontSize: '9px' }}>Original Bus</span>
                            )}
                            {isSubstituteSelected && substituteTrip && (
                              <span className="badge bg-light text-dark border text-capitalize" style={{ fontSize: '9px' }}>
                                {formatServiceType(substituteTrip)}
                              </span>
                            )}
                          </div>
                        </div>

                        {isSubstituteSelected && substituteDate && (
                          <div className="text-end flex-shrink-0">
                            <span className="text-muted text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.5px' }}>
                              Substitute Date
                            </span>
                            <strong className="text-dark d-block" style={{ fontSize: '12px' }}>{substituteDate}</strong>
                          </div>
                        )}
                      </div>

                      {isSubstituteSelected && originalVehicleNo && (
                        <div
                          className="d-flex align-items-center gap-2 px-3 py-2 border-top text-muted"
                          style={{ fontSize: '11px', backgroundColor: '#fbfbfd' }}
                        >
                          <FaInfoCircle size={12} className="text-warning flex-shrink-0" />
                          <span>
                            Regular bus <strong className="text-dark">{originalVehicleNo}</strong> is not running for this trip.
                          </span>
                        </div>
                      )}
                    </div>

                    {todayHoliday ? (
                      <div className="text-center py-5 bg-white rounded-4 border shadow-sm mb-3 px-3">
                        <FaCalendarAlt size={48} className="text-warning mb-3" />
                        <h5 className="fw-bold text-dark mb-2">School Holiday Today</h5>
                        <div className="mb-2">
                          <span className="badge bg-warning text-dark fs-6 px-3 py-1">
                            {todayHoliday.title || 'Holiday'}
                          </span>
                        </div>
                        {todayHoliday.description && (
                          <p className="text-muted small mb-3">{todayHoliday.description}</p>
                        )}
                        <p className="text-danger small mb-0 font-weight-bold">
                          Live transport tracking is not available on school holidays.
                        </p>
                      </div>
                    ) : !isTrackingTimeValid ? (
                      <div className="text-center py-4 bg-white rounded-4 border shadow-sm mb-3 px-3">
                        <FaClock size={40} className="text-warning mb-2" />
                        <h6 className="fw-bold text-dark mb-1">Tracking Time Ended</h6>
                        <p className="text-muted small mb-3">
                          {activeWindowType === "pick"
                            ? "Live tracking for Pick substitute vehicle is only active during pickup hours."
                            : activeWindowType === "drop"
                              ? "Live tracking for Drop substitute vehicle is only active during drop hours."
                              : "Live tracking is only active during scheduled pickup & drop hours."}
                        </p>
                        <div className="d-flex flex-wrap justify-content-center gap-2">
                          {(activeWindowType === "pick" || activeWindowType === "both") && hasPickWindow && (
                            <span className="badge bg-light text-dark border px-3 py-2">
                              <strong>Pick Window:</strong> {format12HourTime(pickStartTime)} - {format12HourTime(pickEndTime)}
                            </span>
                          )}
                          {(activeWindowType === "drop" || activeWindowType === "both") && hasDropWindow && (
                            <span className="badge bg-light text-dark border px-3 py-2">
                              <strong>Drop Window:</strong> {format12HourTime(dropStartTime)} - {format12HourTime(dropEndTime)}
                            </span>
                          )}
                        </div>
                      </div>
                    ) : activeTrackUrl ? (
                      <div className="mb-3 rounded-4 overflow-hidden border shadow-sm bg-white position-relative" style={{ height: "420px" }}>
                        {trackLoading && (
                          <div className="position-absolute top-50 start-50 translate-middle text-center" style={{ zIndex: 15 }}>
                            <Spinner animation="border" variant="primary" />
                            <p className="text-muted small mt-2 mb-0 fw-medium">Loading live transport map...</p>
                          </div>
                        )}
                        <iframe
                          key={trackReloadKey}
                          src={activeTrackUrl}
                          title="Live Transport Location"
                          style={{ width: "100%", height: "100%", border: "none" }}
                          onLoad={handleTrackMapFrameLoad}
                        />
                      </div>
                    ) : (
                      <div className="text-center py-4 bg-white rounded-4 border shadow-sm mb-3">
                        <FaBus size={40} className="text-muted mb-2" />
                        <h6 className="fw-bold text-dark mb-1">Live Location Not Available</h6>
                        <p className="text-muted small mb-0">
                          {isSubstituteSelected
                            ? `Live tracking link for substitute vehicle ${substituteVehicleNo || ''} has not been shared by school admin yet.`
                            : 'Vehicle route tracking link has not been shared by school admin yet.'}
                        </p>
                      </div>
                    )}

                    {/* Transport Details Summary inside Modal */}
                    <div className="bg-white p-3 rounded-4 border shadow-sm">
                      <h6 className="fw-bold text-dark mb-3 d-flex align-items-center gap-2">
                        <FaMapMarkerAlt className="text-danger" />
                        Route & Contact Information
                      </h6>
                      <div className="row g-3 text-dark small">
                        {transportRecord?.stoppage_details?.stop_name && (
                          <div className="col-12 col-md-6">
                            <span className="text-muted d-block">Pickup Stop:</span>
                            <strong className="text-dark fs-14">
                              {transportRecord.stoppage_details.stop_name}
                            </strong>
                          </div>
                        )}
                        {transportRecord?.route_details && (
                          <div className="col-12 col-md-6">
                            <span className="text-muted d-block">Route:</span>
                            <strong className="text-dark fs-14">
                              {transportRecord.route_details.startplace} → {transportRecord.route_details.endplace} ({transportRecord.route_details.code})
                            </strong>
                          </div>
                        )}
                        {(isSubstituteSelected ? (substituteTrip || transportRecord?.service_type) : transportRecord?.service_type) && (
                          <div className="col-6 col-md-6">
                            <span className="text-muted d-block">Service Type:</span>
                            <strong className="text-dark fs-14 text-capitalize">
                              {formatServiceType(isSubstituteSelected ? (substituteTrip || transportRecord?.service_type) : transportRecord?.service_type)}
                            </strong>
                          </div>
                        )}
                        <div className="col-6 col-md-6">
                          <span className="text-muted d-block">Tracked Bus:</span>
                          <strong className="text-dark fs-14">
                            {isSubstituteSelected ? substituteVehicleNo : originalVehicleNo || '--'}
                            {isSubstituteSelected ? (
                              <span className="badge bg-warning text-dark ms-1" style={{ fontSize: '9px' }}>Substitute Bus</span>
                            ) : (
                              <span className="badge bg-secondary ms-1" style={{ fontSize: '9px' }}>Original Bus</span>
                            )}
                          </strong>
                        </div>

                        {isSubstituteSelected ? (
                          <>
                            {(subDriverName || subDriverContact) && (
                              <div className="col-6 col-md-6">
                                <span className="text-warning font-weight-bold d-block">
                                  Substitute Driver {substituteTrip ? `(${formatServiceType(substituteTrip)})` : ''}:
                                </span>
                                <strong className="text-dark fs-14 d-block">
                                  {subDriverName || '--'}
                                </strong>
                                {subDriverContact && (
                                  <a href={`tel:${subDriverContact}`} className="text-primary fw-semibold">
                                    <FaPhone className="me-1" size={12} />
                                    {subDriverContact}
                                  </a>
                                )}
                              </div>
                            )}
                            {(subAttendeeName || subAttendeeContact) && (
                              <div className="col-6 col-md-6">
                                <span className="text-warning font-weight-bold d-block">
                                  Substitute Attendee {substituteTrip ? `(${formatServiceType(substituteTrip)})` : ''}:
                                </span>
                                <strong className="text-dark fs-14 d-block">
                                  {subAttendeeName || '--'}
                                </strong>
                                {subAttendeeContact && (
                                  <a href={`tel:${subAttendeeContact}`} className="text-primary fw-semibold">
                                    <FaPhone className="me-1" size={12} />
                                    {subAttendeeContact}
                                  </a>
                                )}
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            {transportRecord?.driver_details?.morningShiftDriver && (
                              <div className="col-6 col-md-6">
                                <span className="text-muted d-block">Pick Driver:</span>
                                <strong className="text-dark fs-14 d-block">
                                  {transportRecord.driver_details.morningShiftDriver.staff_full_name}
                                </strong>
                                <a href={`tel:${transportRecord?.vehicle_details?.driver_contact_no || transportRecord.driver_details.morningShiftDriver.mobile_no}`} className="text-primary fw-semibold">
                                  <FaPhone className="me-1" size={12} />
                                  {transportRecord?.vehicle_details?.driver_contact_no || transportRecord.driver_details.morningShiftDriver.mobile_no}
                                </a>
                              </div>
                            )}
                            {transportRecord?.driver_details?.eveningShiftDriver && (
                              <div className="col-6 col-md-6">
                                <span className="text-muted d-block">Drop Driver:</span>
                                <strong className="text-dark fs-14 d-block">
                                  {transportRecord.driver_details.eveningShiftDriver.staff_full_name}
                                </strong>
                                <a href={`tel:${transportRecord?.vehicle_details?.driver_contact_no || transportRecord.driver_details.eveningShiftDriver.mobile_no}`} className="text-primary fw-semibold">
                                  <FaPhone className="me-1" size={12} />
                                  {transportRecord?.vehicle_details?.driver_contact_no || transportRecord.driver_details.eveningShiftDriver.mobile_no}
                                </a>
                              </div>
                            )}
                            {transportRecord?.driver_details?.morningShiftAttendee && (
                              <div className="col-6 col-md-6">
                                <span className="text-muted d-block">Pick Attendee:</span>
                                <strong className="text-dark fs-14 d-block">
                                  {transportRecord.driver_details.morningShiftAttendee.staff_full_name}
                                </strong>
                                <a href={`tel:${transportRecord?.vehicle_details?.attendee_contact_no || transportRecord.driver_details.morningShiftAttendee.mobile_no}`} className="text-primary fw-semibold">
                                  <FaPhone className="me-1" size={12} />
                                  {transportRecord?.vehicle_details?.attendee_contact_no || transportRecord.driver_details.morningShiftAttendee.mobile_no}
                                </a>
                              </div>
                            )}
                            {transportRecord?.driver_details?.eveningShiftAttendee && (
                              <div className="col-6 col-md-6">
                                <span className="text-muted d-block">Drop Attendee:</span>
                                <strong className="text-dark fs-14 d-block">
                                  {transportRecord.driver_details.eveningShiftAttendee.staff_full_name}
                                </strong>
                                <a href={`tel:${transportRecord?.vehicle_details?.attendee_contact_no || transportRecord.driver_details.eveningShiftAttendee.mobile_no}`} className="text-primary fw-semibold">
                                  <FaPhone className="me-1" size={12} />
                                  {transportRecord?.vehicle_details?.attendee_contact_no || transportRecord.driver_details.eveningShiftAttendee.mobile_no}
                                </a>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })()}
            </Modal.Body>
          </Modal>

          {/* Event Vehicle Tracking Modal (Identical logic to Event.js) */}
          <Modal
            show={showEventTrackModal}
            onHide={() => setShowEventTrackModal(false)}
            size="lg"
            centered
          >
            <Modal.Header closeButton className="border-0 pb-2">
              <Modal.Title className="d-flex align-items-center gap-2 text-primary fs-16 fw-bold">
                <FaBus />
                Vehicle Tracking
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-0">
              <div className="mb-3">
                <h5 className="fw-bold text-dark mb-1">
                  {activeEventTrackItem?.event_name || activeEventTrackBooking?.category?.title || 'Selected Event'}
                </h5>
                {(activeEventTrackBooking?.category?.event_location) && (
                  <small className="text-muted d-flex align-items-center gap-1">
                    <FaMapMarkerAlt />
                    {activeEventTrackBooking?.category?.event_location}
                  </small>
                )}
              </div>

              {eventTrackLoading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" size="sm" />
                  <p className="text-muted small mt-2 mb-0">Loading tracking details...</p>
                </div>
              ) : isEventTrackingTimeAllowed(activeEventTrackItem || {}, activeEventTrackBooking) ? (
                <>
                  <EventBusArrivingCard info={eventTrackBusInfo} />

                  {eventTrackVehicleOptions.length > 0 ? (
                    <>
                      {eventTrackVehicleOptions.length > 1 && (
                        <div className="mb-3 p-3 bg-light rounded-3 border">
                          <label className="fw-semibold form-label d-block mb-2 text-dark">Select Vehicle</label>
                          <div className="d-flex flex-wrap gap-3">
                            {eventTrackVehicleOptions.map((opt, idx) => (
                              <div key={idx} className="form-check form-check-inline d-flex align-items-center mb-0">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="eventVehicleTrackRadioIndex"
                                  id={`eventVehicleTrackRadioIndex_${idx}`}
                                  value={opt.value}
                                  checked={selectedEventTrackUrl === opt.value}
                                  onChange={(e) => setSelectedEventTrackUrl(e.target.value)}
                                  style={{ cursor: 'pointer' }}
                                />
                                <label
                                  className="form-check-label ms-2 fw-medium text-dark"
                                  htmlFor={`eventVehicleTrackRadioIndex_${idx}`}
                                  style={{ cursor: 'pointer', fontSize: '13px' }}
                                >
                                  {opt.label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {selectedEventTrackUrl ? (
                        <div className="border rounded-3 overflow-hidden shadow-sm">
                          <iframe
                            src={selectedEventTrackUrl}
                            width="100%"
                            height="420"
                            style={{ border: 'none' }}
                            title="Vehicle Tracking Map"
                          />
                        </div>
                      ) : (
                        <div className="alert alert-info text-center py-4 my-2">
                          <FaMapMarkerAlt className="fs-1 mb-2" />
                          <p className="mb-0">Select a vehicle to start tracking.</p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="alert alert-warning text-center py-4 my-2">
                      <FaBus className="fs-1 mb-2" />
                      <p className="mb-0">
                        {eventTrackBusInfo?.hasSubstitute
                          ? `Live tracking link for substitute vehicle ${eventTrackBusInfo?.substitute?.vehicleNumber || ''} has not been shared by school admin yet.`
                          : 'No vehicle tracking details available for this event.'}
                      </p>
                    </div>
                  )}

                  <EventBusContactCard info={eventTrackBusInfo} />
                </>
              ) : (
                <div className="alert alert-warning text-center py-4 my-3 rounded-3 shadow-sm border-warning">
                  <FaClock className="fs-1 text-warning mb-2" />
                  <h5 className="fw-bold text-dark">Vehicle Tracking Unavailable</h5>
                  <p className="mb-0 text-muted small">
                    Tracking is only active between event dates: <br />
                    <strong className="text-dark">
                      {formatDateDisplay(activeEventTrackItem?.start_date || activeEventTrackBooking?.category?.start_date)}
                    </strong>
                    {' '}to{' '}
                    <strong className="text-dark">
                      {formatDateDisplay(activeEventTrackItem?.end_date || activeEventTrackBooking?.category?.end_date || activeEventTrackItem?.due_date || activeEventTrackBooking?.category?.due_date)}
                    </strong>.
                  </p>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0">
              <button
                type="button"
                className="btn btn-secondary btn-sm px-4 rounded-pill"
                onClick={() => setShowEventTrackModal(false)}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>

          <CommonFooterNav />

        </div>

        {sidebarOpen && (
          <CommonSidebar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />
        )}

      </div>

      <style jsx>{`
        @keyframes blinkSuspended {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.45; transform: scale(0.97); }
        }
        @keyframes blinkSuspendedIcon {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.2; }
        }
        @keyframes blinkSuspendedBanner {
          0%, 100% { opacity: 1; background-color: #fff5f5; }
          50% { opacity: 0.7; background-color: #fee2e2; }
        }
        .app-update-banner-wrap {
          position: fixed;
          top: 16px;
          right: 16px;
          z-index: 2000;
          display: flex;
          flex-direction: column;
          gap: 10px;
          width: min(340px, calc(100vw - 32px));
        }
        .app-update-banner {
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: flex-start;
          gap: 12px;
          background: #ffffff;
          border: 1px solid #e6ecf5;
          border-left: 4px solid #2563eb;
          color: #1e293b;
          border-radius: 14px;
          padding: 14px 16px 16px;
          font-size: 13px;
          box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14), 0 2px 6px rgba(15, 23, 42, 0.06);
          animation: app-update-banner-slide-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }
        @keyframes app-update-banner-slide-in {
          from {
            opacity: 0;
            transform: translateX(24px) scale(0.97);
          }
          to {
            opacity: 1;
            transform: translateX(0) scale(1);
          }
        }
        .app-update-banner-icon-badge {
          flex-shrink: 0;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #dbeafe, #eff6ff);
        }
        .app-update-banner-icon {
          color: #2563eb;
          font-size: 16px;
        }
        .app-update-banner-body {
          flex: 1;
          min-width: 0;
          padding-top: 2px;
        }
        .app-update-banner-title {
          font-weight: 700;
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: #2563eb;
          margin-bottom: 3px;
        }
        .app-update-banner-text {
          color: #334155;
          font-weight: 500;
          line-height: 1.45;
          word-break: break-word;
        }
        .app-update-banner-ok {
          flex-shrink: 0;
          border: none;
          background: linear-gradient(135deg, #2563eb, #1d4ed8);
          color: #ffffff;
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.02em;
          cursor: pointer;
          box-shadow: 0 4px 10px rgba(37, 99, 235, 0.35);
          transition: transform 0.15s ease, box-shadow 0.15s ease;
        }
        .app-update-banner-ok:hover {
          transform: translateY(-1px);
          box-shadow: 0 6px 14px rgba(37, 99, 235, 0.4);
        }
        .app-update-banner-ok:active {
          transform: translateY(0);
        }
        .app-update-banner-timer {
          position: absolute;
          left: 0;
          bottom: 0;
          height: 3px;
          width: 100%;
          background: linear-gradient(90deg, #60a5fa, #2563eb);
          transform-origin: left;
          animation-name: app-update-banner-shrink;
          animation-timing-function: linear;
          animation-fill-mode: forwards;
        }
        @keyframes app-update-banner-shrink {
          from {
            transform: scaleX(1);
          }
          to {
            transform: scaleX(0);
          }
        }
        .new-event-tile-blink {
          position: relative;
          animation: newEventTileBlink 1.2s infinite ease-in-out;
          border: 2px solid #f59e0b !important;
        }
        @keyframes newEventTileBlink {
          0%, 100% {
            box-shadow: 0 0 4px rgba(245, 158, 11, 0.35);
            background-color: #ffffff;
          }
          50% {
            box-shadow: 0 0 14px rgba(245, 158, 11, 0.8);
            background-color: #fffbeb;
          }
        }
        .new-event-star {
          position: absolute;
          top: 2px;
          right: 8px;
          color: #dc2626;
          font-size: 20px;
          font-weight: 700;
          line-height: 1;
          animation: blinkSuspendedIcon 1s infinite ease-in-out;
        }
        .fee-pending-tile-blink {
          animation: feeTileBlinkAlert 1.2s infinite ease-in-out;
          border: 2px solid #ef4444 !important;
          border-radius: 12px;
        }
        @keyframes feeTileBlinkAlert {
          0%, 100% {
            box-shadow: 0 0 6px rgba(239, 68, 68, 0.4), 0 0 14px rgba(239, 68, 68, 0.2);
            border-color: #ef4444;
            background-color: #fff5f5;
          }
          50% {
            box-shadow: 0 0 18px rgba(239, 68, 68, 0.85), 0 0 28px rgba(239, 68, 68, 0.5);
            border-color: #dc2626;
            background-color: #ffe4e6;
          }
        }
        .red-bg-blink {
          background: linear-gradient(135deg, #ef4444, #dc2626) !important;
          color: #ffffff !important;
          animation: iconPulseBlink 1.2s infinite ease-in-out;
        }
        @keyframes iconPulseBlink {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.6);
          }
          50% {
            transform: scale(1.08);
            box-shadow: 0 0 0 8px rgba(239, 68, 68, 0);
          }
        }
        .btn-pulse {
          animation: payBtnPulse 1.2s infinite ease-in-out;
        }
        @keyframes payBtnPulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 2px 6px rgba(220, 38, 38, 0.4);
          }
          50% {
            transform: scale(1.06);
            box-shadow: 0 4px 14px rgba(220, 38, 38, 0.7);
          }
        }
      `}</style>

    </>
  );
};

export default Home;
